/**
 * Live TV Page – Tab items fetch and populate (Last 24 Items, Best Buys, Last 24 Hours).
 * Reads config from [data-tab-items-grid] (data-tab-api-url, data-cards-limit, data-money-format).
 * Last 24 Hours: fetches data.hours[], builds inner hour tabs, filters grid by selected hour.
 * Cards are shown only when auction.shopifyData is present and non-empty (synced product).
 */
(function () { 
  function formatNumber(num, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    if (num == null || isNaN(Number(num))) return '';
    var fixed = Number(num).toFixed(precision);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    if (precision === 0) return parts[0];
    return parts[0] + decimal + parts[1];
  }

  function formatMoney(amount, moneyFormat) {
    if (amount == null || isNaN(Number(amount))) return '';
    var num = Number(amount);
    var format = moneyFormat || '{{amount}}';
    var tokenValues = {
      amount: formatNumber(num, 2, ',', '.'),
      amount_no_decimals: formatNumber(num, 0, ',', '.'),
      amount_with_comma_separator: formatNumber(num, 2, '.', ','),
      amount_no_decimals_with_comma_separator: formatNumber(num, 0, '.', ','),
      amount_with_space_separator: formatNumber(num, 2, ' ', ','),
      amount_no_decimals_with_space_separator: formatNumber(num, 0, ' ', ','),
      amount_with_apostrophe_separator: formatNumber(num, 2, "'", '.')
    };

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, token) {
      return Object.prototype.hasOwnProperty.call(tokenValues, token) ? tokenValues[token] : '';
    });
  }

  /** "9 AM" from an hour slot label ("9.00 AM to 10.00 AM", "9:00am"), or from showDate when the
      label is a 00.00 placeholder. Empty string when neither gives a time. */
  function formatAirHourLabel(hourValue, showDate) {
    var rawHour = hourValue != null ? String(hourValue).trim() : '';
    var hasPlaceholderHour = rawHour === '' || rawHour === '00.00' || rawHour === '00:00';
    if (hasPlaceholderHour && showDate) {
      var d = new Date(showDate);
      if (!isNaN(d.getTime())) {
        return d.toLocaleTimeString('en-GB', { hour: 'numeric', hour12: true }).replace(/\s+/g, ' ');
      }
    }
    if (!rawHour) return '';
    var firstSlot = rawHour.split(/\s*(?:to|-|–|—)\s*/i)[0] || rawHour;
    return firstSlot
      .replace(/\./g, ':')
      .replace(/\s*([AaPp])[.]?[Mm][.]?$/, ' $1M')
      .replace(/(\d)([AaPp])[Mm]?$/, '$1 $2M')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  /** Recently On Air: "Caroline Lyndsay at 9 AM" (presenterName/airHour stamped by /last-24-items). */
  function airSlotHtml(item) {
    var name = String(item.presenterName || '').replace(/\./g, ' ').replace(/\s+/g, ' ').trim();
    /* Card copy is "9 AM": drop whole-hour minutes here only (the hour tabs keep their labels). */
    var time = formatAirHourLabel(item.airHour, item.airShowDate).toUpperCase().replace(/:00(?= [AP]M$)/, '');
    var text = name && time ? name + ' at ' + time : name || time;
    if (!text) return '';
    return '<p class="missed-auction-card__air-slot">' + text.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</p>';
  }

  function isShopifyDataEmpty(sd) {
    if (!sd || typeof sd !== 'object') return true;
    var hasId = sd.productId && String(sd.productId).trim() !== '';
    var hasName = sd.productName && String(sd.productName).trim() !== '';
    return !hasId && !hasName;
  }

  /** Omit cards when shopifyData is null/undefined or not usable (sync failed / not in Shopify). */
  function auctionHasShopifyProduct(item) {
    return item && item.shopifyData != null && typeof item.shopifyData === 'object' && !isShopifyDataEmpty(item.shopifyData);
  }

  function hasGlaMla(item) {
    var isGroup = item.isGroupAuction === true;
    var isMla = item.isMLAAuction === true;
    var ga = item.groupauctions || item.groupAuctions;
    if (!isGroup || !isMla || !ga || !ga.length) return false;
    for (var i = 0; i < ga.length; i++) {
      var mla = ga[i].mlauctions || ga[i].mlaAuctions;
      if (mla && mla.length > 0) return true;
    }
    return false;
  }

  function hasGlaOnly(item) {
    var isGroup = item.isGroupAuction === true;
    var isMla = item.isMLAAuction === true;
    var ga = item.groupauctions || item.groupAuctions;
    return isGroup && !isMla && ga && ga.length > 0;
  }

  function getLabel(ga) {
    return (ga && (ga.variant || ga.itemName || ga.ItemSize || ga.itemSize || ga.stockCode || ga.StockCode || ga.auctionCode || ga.AuctionCode || '')) ? String(ga.variant || ga.itemName || ga.ItemSize || ga.itemSize || ga.stockCode || ga.StockCode || ga.auctionCode || ga.AuctionCode).trim() : '';
  }

  function getStockCode(ga) {
    return (ga && (ga.stockCode != null || ga.StockCode != null)) ? String(ga.stockCode != null ? ga.stockCode : ga.StockCode).trim() : '';
  }

  /** AMS stock on a group-auction row (REST quantity; fallback stockRemaining). */
  function amsGroupRowQuantity(row) {
    if (!row || typeof row !== 'object') return 0;
    var v = row.quantity != null ? row.quantity
      : row.Quantity != null ? row.Quantity
      : row.stockRemaining != null ? row.stockRemaining
      : row.StockRemaining;
    if (v == null || v === '') return 0;
    var n = Number(v);
    return isFinite(n) ? n : 0;
  }

  function isGroupAuctionBuyAllSku(sku) {
    return !!sku && String(sku).trim().toUpperCase() === 'BUYALL';
  }

  /** Non-BUYALL group rows with AMS quantity > 0 (SFCC getAvailableOptions). */
  function countAvailableGroupVariants(groupauctions) {
    if (!Array.isArray(groupauctions)) return 0;
    var count = 0;
    for (var i = 0; i < groupauctions.length; i++) {
      var sku = getStockCode(groupauctions[i]);
      if (!sku || isGroupAuctionBuyAllSku(sku)) continue;
      if (amsGroupRowQuantity(groupauctions[i]) > 0) count++;
    }
    return count;
  }

  function auctionDisplaySizeForSort(item, variantSizeBySku) {
    if (!item || typeof item !== 'object') return '';
    var sku = getStockCode(item);
    var size = String(
      item.ItemSize != null ? item.ItemSize :
      item.itemSize != null ? item.itemSize :
      item.variant != null ? item.variant :
      item.Variant != null ? item.Variant :
      (variantSizeBySku && sku && variantSizeBySku[sku]) || ''
    ).trim();
    return size || sku;
  }

  function sortAuctionItemsByDisplaySize(items, variantSizeBySku) {
    if (typeof window._liveTvSortAuctionItemsByDisplaySize === 'function') {
      return window._liveTvSortAuctionItemsByDisplaySize(items, variantSizeBySku);
    }
    if (!Array.isArray(items) || items.length < 2) return items ? items.slice() : [];
    return items.slice().sort(function (a, b) {
      return auctionDisplaySizeForSort(a, variantSizeBySku).localeCompare(
        auctionDisplaySizeForSort(b, variantSizeBySku),
        undefined,
        { sensitivity: 'base', numeric: true }
      );
    });
  }

  /** Per-variant auction line code for cart / order line properties (not package-level). */
  function getMlaRowAuctionCode(mla) {
    if (!mla || typeof mla !== 'object') return '';
    var v = mla.auctionCode != null ? mla.auctionCode : (mla.AuctionCode != null ? mla.AuctionCode : '');
    return String(v).trim();
  }

  /**
   * Second MLA dropdown options for the selected GLA (color/group) auction code.
   * Include: prime row (auctionCode === gla), child under that GLA (mlaAuctionCode === gla),
   * or sibling MLA tied to same prime+mla codes (prime === gla && mla === gla).
   * Excludes rows that only share primeAuctionCode with a different color (e.g. beige row with prime=black).
   */
  function filterMlaAuctionsForGlaCode(glaCode, mlaAuctions) {
    if (!glaCode || !Array.isArray(mlaAuctions) || mlaAuctions.length === 0) return [];
    var g = String(glaCode).trim();
    return mlaAuctions.filter(function (item) {
      var ac = String(item.auctionCode != null ? item.auctionCode : (item.AuctionCode != null ? item.AuctionCode : '')).trim();
      var prime = String(item.primeAuctionCode != null ? item.primeAuctionCode : (item.PrimeAuctionCode != null ? item.PrimeAuctionCode : '')).trim();
      var mlaC = String(item.mlaAuctionCode != null ? item.mlaAuctionCode : (item.MLAuctionCode != null ? item.MLAuctionCode : '')).trim();
      if (ac === g) return true;
      if (mlaC === g) return true;
      if (prime === g && mlaC === g) return true;
      return false;
    });
  }

  function setFormLinePnp(form, value) {
    var inp = form && form.querySelector('input[name="properties[_pnp]"]');
    if (inp) inp.value = value != null ? String(value) : '';
  }

  function applyPnpFromOption(form, opt) {
    if (!form || !opt || !opt.getAttribute) return;
    var p = opt.getAttribute('data-pnp');
    if (p != null && String(p) !== '') setFormLinePnp(form, p);
  }

  function pnpFromAuctionJson(item) {
    if (!item || typeof item !== 'object') return '';
    var v = item.PnPAmount != null ? item.PnPAmount : item.pnpAmount;
    return v != null && String(v) !== '' ? String(v) : '';
  }

  /** True when Shopify says this SKU line is not available for sale (inventoryBySku from API). */
  function liveTvSkuSoldOutFromInventoryBySku(invBySku, sku) {
    if (!invBySku || typeof invBySku !== 'object' || !sku) return false;
    var ent = invBySku[sku] || invBySku[String(sku).trim()];
    return !!(ent && ent.availableForSale === false);
  }

  /** AMS stock left on an auction row; null when the row carries no figure. */
  function auctionRowStockRemaining(row) {
    if (!row || typeof row !== 'object') return null;
    var v = row.StockRemaining != null ? row.StockRemaining : row.stockRemaining;
    return v != null ? Number(v) : null;
  }

  /** The rule MLA options are painted with: AMS says none left, or Shopify says not for sale. */
  function auctionRowSoldOut(row, invBySku) {
    var remaining = auctionRowStockRemaining(row);
    if (remaining !== null && remaining === 0) return true;
    return liveTvSkuSoldOutFromInventoryBySku(invBySku, getStockCode(row));
  }

  /** MLA rows sitting under one GLA row — the sizes behind a colour. */
  function nestedMlaRows(ga) {
    var mla = ga && (ga.mlauctions || ga.mlaAuctions);
    return Array.isArray(mla) ? mla : [];
  }

  /**
   * The GLA row is itself one of the sizes — AMS puts that size's stock code on the group row and
   * leaves it out of `mlauctions` (Grey = 7898145/L with only 7898144/M nested). Reshape it as an
   * MLA row so it can be offered like any other size. Its `variant` holds the group label ("Grey"),
   * never a size, so the size label comes from the Shopify variant title instead.
   */
  function glaRowAsSizeRow(ga, variantSizeBySku) {
    var sku = getStockCode(ga);
    if (!sku || isGroupAuctionBuyAllSku(sku)) return null;
    var size = String(
      (variantSizeBySku && variantSizeBySku[sku]) ||
      (ga.ItemSize != null ? ga.ItemSize : (ga.itemSize != null ? ga.itemSize : ''))
    ).trim();
    var row = {};
    for (var k in ga) {
      if (Object.prototype.hasOwnProperty.call(ga, k)) row[k] = ga[k];
    }
    delete row.mlauctions;
    delete row.mlaAuctions;
    row.ItemSize = size;
    row.itemSize = size;
    row.variant = size;
    row.Variant = size;
    return row;
  }

  /** Every size behind one GLA option: the group row itself, then its MLA rows. */
  function glaSizeRows(ga, flatMlaAuctions, variantSizeBySku) {
    if (!ga) return [];
    var nested = nestedMlaRows(ga);
    if (nested.length === 0) {
      var code = String(ga.auctionCode != null ? ga.auctionCode : (ga.AuctionCode != null ? ga.AuctionCode : '')).trim();
      nested = filterMlaAuctionsForGlaCode(code, flatMlaAuctions);
    }
    var rows = [];
    var master = glaRowAsSizeRow(ga, variantSizeBySku);
    if (master) {
      var masterSku = getStockCode(master);
      var dup = false;
      for (var d = 0; d < nested.length; d++) {
        if (getStockCode(nested[d]) === masterSku) { dup = true; break; }
      }
      if (!dup) rows.push(master);
    }
    for (var i = 0; i < nested.length; i++) rows.push(nested[i]);
    return rows;
  }

  /**
   * A GLA option is the parent choice; the sizes under it are what the second dropdown offers.
   * Judging it by its own stock code locks the shopper out of every in-stock size whenever that
   * one size is gone, so it is sold out only when every size it leads to is — individual sold-out
   * sizes stay visible (and disabled) in the second dropdown.
   */
  function glaOptionSoldOut(ga, invBySku, flatMlaAuctions, variantSizeBySku) {
    var rows = glaSizeRows(ga, flatMlaAuctions, variantSizeBySku);
    if (rows.length === 0) return liveTvSkuSoldOutFromInventoryBySku(invBySku, getStockCode(ga));
    for (var i = 0; i < rows.length; i++) {
      if (!auctionRowSoldOut(rows[i], invBySku)) return false;
    }
    return true;
  }

  function liveTvReadInventoryBySkuFromCard(cardEl) {
    if (!cardEl || !cardEl.getAttribute) return null;
    var raw = cardEl.getAttribute('data-shopify-inventory');
    if (!raw) return null;
    try {
      var parsed = JSON.parse(String(raw).replace(/&quot;/g, '"'));
      return parsed && parsed.inventoryBySku && typeof parsed.inventoryBySku === 'object'
        ? parsed.inventoryBySku
        : null;
    } catch (e) {
      return null;
    }
  }

  /**
   * Ring resize (Live TV): a group auction whose sizes are cut from one physical master ring.
   * Detected when any group SKU's inventoryBySku entry carries ringResizer + resizeProductVariantId
   * (variant metafields via enrichment). Master availability governs every size option.
   * @returns {{ masterSku: string, masterAvailable: boolean, masterSize: string } | null}
   */
  function liveTvRingResizeFromShopifyData(sd, groupauctions) {
    var inv = sd && sd.inventoryBySku;
    if (!inv || typeof inv !== 'object' || !Array.isArray(groupauctions) || groupauctions.length === 0) return null;
    var masterSku = '';
    for (var i = 0; i < groupauctions.length; i++) {
      var sku = getStockCode(groupauctions[i]);
      if (!sku || sku.toUpperCase() === 'BUYALL') continue;
      var ent = inv[sku];
      if (ent && ent.ringResizer === true && ent.resizeProductVariantId) {
        masterSku = String(ent.resizeProductVariantId).trim();
        if (masterSku) break;
      }
    }
    if (!masterSku) return null;
    var masterEnt = inv[masterSku];
    if (!masterEnt) return null;
    var masterSize = (sd.variantSizeBySku && sd.variantSizeBySku[masterSku]) || '';
    if (!masterSize) {
      for (var j = 0; j < groupauctions.length; j++) {
        if (getStockCode(groupauctions[j]) === masterSku) {
          var mrow = groupauctions[j];
          masterSize = String(mrow.ItemSize || mrow.itemSize || mrow.variant || mrow.Variant || '').trim();
          break;
        }
      }
    }
    return {
      masterSku: masterSku,
      masterAvailable: masterEnt.availableForSale === true,
      masterSize: masterSize
    };
  }

  /** Normalize variant id for /cart/add: use numeric id (strip GID prefix if present) */
  function normalizeVariantId(id) {
    if (id == null || id === '') return '';
    var s = String(id).trim();
    if (s.indexOf('gid://') === 0) {
      var match = s.match(/ProductVariant\/(\d+)/i);
      return match ? match[1] : s;
    }
    return s;
  }

  /** Shopify PDP link: `/products/handle?variant=ID`. Empty variantId strips `variant`. */
  function productUrlWithVariant(baseUrl, variantId) {
    if (!baseUrl) return '';
    var s = String(baseUrl).trim();
    if (!s || s.indexOf('/search') === 0) return s;
    var hash = '';
    var hashIdx = s.indexOf('#');
    if (hashIdx >= 0) {
      hash = s.slice(hashIdx);
      s = s.slice(0, hashIdx);
    }
    var path = s;
    var query = '';
    var qIdx = s.indexOf('?');
    if (qIdx >= 0) {
      path = s.slice(0, qIdx);
      query = s.slice(qIdx + 1);
    }
    var params = [];
    if (query) {
      query.split('&').forEach(function (part) {
        if (!part) return;
        var eq = part.indexOf('=');
        var key = eq >= 0 ? decodeURIComponent(part.slice(0, eq)) : decodeURIComponent(part);
        if (key === 'variant') return;
        params.push(part);
      });
    }
    var vid = variantId != null ? String(variantId).trim() : '';
    if (vid) params.push('variant=' + encodeURIComponent(vid));
    return path + (params.length ? '?' + params.join('&') : '') + hash;
  }

  function getCardProductBaseUrl(cardEl) {
    if (!cardEl) return '';
    var base = (cardEl.getAttribute('data-product-url') || '').trim();
    if (!base) {
      var withAttr = cardEl.querySelector('[data-product-url]');
      if (withAttr) base = (withAttr.getAttribute('data-product-url') || '').trim();
    }
    if (base) return productUrlWithVariant(base, '');
    var mediaLink = cardEl.querySelector('.missed-auction-card__media-link, .currently-on-air-card__media-link');
    var titleLink = cardEl.querySelector('.missed-auction-card__title a, .currently-on-air-card__title a');
    var href = (mediaLink && mediaLink.getAttribute('href')) || (titleLink && titleLink.getAttribute('href')) || '';
    return productUrlWithVariant(href, '');
  }

  /** Sync media/title links from hidden input[name=id]. Buy All → plain product URL. */
  function syncCardProductLinks(cardEl, form) {
    if (!cardEl) return;
    var base = getCardProductBaseUrl(cardEl);
    if (!base || base.indexOf('/search') === 0) return;
    var variantSelect = form && form.querySelector('[data-variant-select]');
    var isBuyAll = !!(variantSelect && variantSelect.value === 'buy-all');
    var hiddenId = form && form.querySelector('input[name="id"]');
    var vid = (!isBuyAll && hiddenId) ? normalizeVariantId(hiddenId.value) : '';
    var href = productUrlWithVariant(base, vid);
    var mediaLink = cardEl.querySelector('.missed-auction-card__media-link, .currently-on-air-card__media-link');
    var titleLink = cardEl.querySelector('.missed-auction-card__title a, .currently-on-air-card__title a');
    if (mediaLink) mediaLink.href = href;
    if (titleLink) titleLink.href = href;
  }

  /** Placeholder image URL from section root [data-ltv-no-img] (Liquid: ltv-no-image.webp). */
  function liveTvNoImageUrl() {
    var el = document.querySelector('[data-ltv-no-img]');
    return el ? el.getAttribute('data-ltv-no-img') : '';
  }

  /* ---------------------------------------------------------------------------
   * Card images
   *
   * Every card image is native Shopify product media, served from cdn.shopify.com
   * at its original size — a card that paints a 342 px box was pulling 269 KB
   * originals, 4.6 MB of waste across one Missed Auctions page. Appending &width=
   * makes the CDN resize, and it content-negotiates WebP on top of that: the same
   * measured image drops 269 KB -> 32 KB (jpeg) -> 26 KB (webp), with no markup
   * change and no re-upload.
   *
   * Anything that is not a Shopify CDN URL (the local ltv-no-image.webp placeholder,
   * a presenter avatar on another host) is returned untouched.
   * ------------------------------------------------------------------------- */

  /** Rendered box is 342 CSS px on desktop, ~179 px on mobile. */
  var LTV_CARD_IMG_WIDTH = 400;
  /** Currently-On-Air thumbnail paints at 150 CSS px. */
  var LTV_COA_IMG_WIDTH = 200;
  var LTV_CARD_IMG_SIZES = '(max-width: 749px) 45vw, 342px';
  /** Images above this index stay lazy; the first few are what LCP is measured on. */
  var LTV_EAGER_CARD_COUNT = 4;

  function ltvIsShopifyCdnUrl(url) {
    return typeof url === 'string' && url.indexOf('cdn.shopify.com') !== -1;
  }

  /** Same URL with an explicit render width. Existing `width` is replaced, not duplicated. */
  function ltvImgUrl(url, width) {
    if (!ltvIsShopifyCdnUrl(url)) return url || '';
    var clean = String(url).replace(/([?&])width=\d+&?/g, '$1').replace(/[?&]$/, '');
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /** 1x/2x pair, so retina phones stay sharp without every device paying for 2x. */
  function ltvImgSrcset(url, width) {
    if (!ltvIsShopifyCdnUrl(url)) return '';
    return ltvImgUrl(url, width) + ' 1x, ' + ltvImgUrl(url, width * 2) + ' 2x';
  }

  /**
   * Build a card <img> tag.
   * `eager` marks the image as an LCP candidate: on Missed Auctions the first card
   * image IS the LCP element, and shipping it `loading="lazy"` is what put LCP at
   * 32.5 s — the browser will not even start the request until layout settles.
   */
  function ltvImgTag(url, opts) {
    opts = opts || {};
    var width = opts.width || LTV_CARD_IMG_WIDTH;
    var esc = function (s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); };
    var srcset = ltvImgSrcset(url, width);
    return (
      '<img src="' + esc(ltvImgUrl(url, width)) + '"' +
      (srcset ? ' srcset="' + esc(srcset) + '"' : '') +
      (srcset && opts.sizes ? ' sizes="' + esc(opts.sizes) + '"' : '') +
      ' alt="' + esc(opts.alt || '') + '"' +
      ' width="' + (opts.boxWidth || 342) + '" height="' + (opts.boxHeight || 342) + '"' +
      (opts.eager ? ' loading="eager" fetchpriority="high"' : ' loading="lazy"') +
      ' decoding="async"' +
      ' class="' + esc(opts.className || '') + '"' +
      (opts.extra ? ' ' + opts.extra : '') +
      ' />'
    );
  }

  /**
   * Point an existing <img> at a new source. srcset has to move with src — a stale
   * srcset outranks the new src and the browser would keep painting the old image.
   */
  /** Word count with the same steps as live-tv-product-highlights.liquid (space before each tag). */
  function ltvHighlightsWordCount(html) {
    var text = String(html || '')
      .replace(/</g, ' <')
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim();
    return text ? text.split(/\s+/).length : 0;
  }

  function ltvSetImgSrc(imgEl, url, width) {
    if (!imgEl || imgEl.tagName !== 'IMG') return;
    width = width || LTV_CARD_IMG_WIDTH;
    imgEl.src = ltvImgUrl(url, width);
    var srcset = ltvImgSrcset(url, width);
    if (srcset) imgEl.setAttribute('srcset', srcset);
    else imgEl.removeAttribute('srcset');
  }

  /* Shared with live-tv-card-forms.js, which renders the same cards after a SKU change. */
  window.ltvImgUrl = ltvImgUrl;
  window.ltvImgSrcset = ltvImgSrcset;
  window.ltvImgTag = ltvImgTag;
  window.ltvSetImgSrc = ltvSetImgSrc;

  function liveTvMissedPlaceholderHtml(eager) {
    var url = liveTvNoImageUrl();
    if (!url) {
      return '<div class="missed-auction-card__img missed-auction-card__img--placeholder" aria-hidden="true"></div>';
    }
    /* A card with no product media still paints something in the LCP slot, so the
       first cards' placeholders load eagerly for the same reason their images do. */
    return '<img src="' + String(url).replace(/"/g, '&quot;') + '" alt="" width="342" height="342" ' +
      (eager ? 'loading="eager" fetchpriority="high"' : 'loading="lazy"') +
      ' decoding="async" class="missed-auction-card__img missed-auction-card__img--placeholder" aria-hidden="true" />';
  }

  function liveTvCoaPlaceholderHtml() {
    var url = liveTvNoImageUrl();
    if (!url) {
      return '<div class="currently-on-air-card__img currently-on-air-card__img--placeholder" aria-hidden="true"></div>';
    }
    return '<img src="' + String(url).replace(/"/g, '&quot;') + '" alt="" width="150" height="150" loading="lazy" class="currently-on-air-card__img currently-on-air-card__img--placeholder" aria-hidden="true" />';
  }

  /** Star path from product-reviews snippet (viewBox 0 0 32 32) */
  var STAR_PATH = 'M31.547 12a.848.848 0 00-.677-.577l-9.427-1.376-4.224-8.532a.847.847 0 00-1.516 0l-4.218 8.534-9.427 1.355a.847.847 0 00-.467 1.467l6.823 6.664-1.612 9.375a.847.847 0 001.23.893l8.428-4.434 8.432 4.432a.847.847 0 001.229-.894l-1.615-9.373 6.822-6.665a.845.845 0 00.214-.869z';

  /** Figma half-star shape (viewBox 0 0 11 10) — same path as product-reviews.liquid */
  var HALF_STAR_SHAPE_PATH =
    'M5.59251 0.139337C6.11017 1.11823 6.63731 2.09308 7.15992 3.06984L10.4921 3.62351C10.6369 3.64699 10.7347 3.7812 10.7107 3.92338C10.7012 3.9783 10.6754 4.0257 10.6387 4.06291L8.27539 6.42861L8.76725 9.7019C8.78852 9.84452 8.68807 9.97652 8.54236 9.99734C8.48173 10.0058 8.42336 9.9938 8.37404 9.96722L5.35727 8.50288L2.32834 9.97255C2.19667 10.0363 2.03739 9.98318 1.97268 9.85472C1.9478 9.80556 1.94056 9.75241 1.9478 9.70191L2.43965 6.42862L0.0758645 4.06337C-0.0268514 3.96017 -0.0250408 3.79539 0.0799369 3.6944C0.124281 3.65144 0.18039 3.62752 0.237859 3.62132L3.55465 3.0703L5.12205 0.139796C5.18993 0.0126725 5.35057 -0.0369366 5.48043 0.0295044C5.53066 0.0551945 5.56853 0.0937138 5.59251 0.139337Z';

  function buildHalfStarSvg(maskId) {
    return (
      '<svg class="stars half-star" xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none" role="presentation" aria-hidden="true">' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="' +
      HALF_STAR_SHAPE_PATH +
      '" fill="#ff8d00"/>' +
      '<mask id="' +
      maskId +
      '" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="11" height="10">' +
      '<path fill-rule="evenodd" clip-rule="evenodd" d="' +
      HALF_STAR_SHAPE_PATH +
      '" fill="black"/>' +
      '</mask>' +
      '<g mask="url(#' +
      maskId +
      ')">' +
      '<path d="M5.35547 0.0195312H10.7126V10.0195H5.35547V0.0195312Z" fill="#bbbbbb"/>' +
      '</g></svg>'
    );
  }

  /** Build rating HTML for missed auction card (matches product-reviews: SVG stars, Figma half-star mask).
   * Legacy thresholds: 0.3-0.7 = half star; >0.7 = extra full star; <0.3 = no extra. */
  function buildRatingHtml(averageRating, reviewCount, uniqueId) {
    if (averageRating == null || isNaN(Number(averageRating))) return '';
    if (reviewCount == null || isNaN(Number(reviewCount)) || Number(reviewCount) <= 0) return '';
    var rating = Math.min(5, Math.max(0, Number(averageRating)));
    var full = Math.floor(rating);
    var dec = rating % 1;
    var half = false;
    if (dec > 0.7) {
      full += 1;
    } else if (dec >= 0.3) {
      half = true;
    }
    var empty = 5 - full - (half ? 1 : 0);
    var id = (uniqueId && String(uniqueId).replace(/[^a-zA-Z0-9-_]/g, '')) || 'r-' + Math.random().toString(36).slice(2, 11);
    var uniqueId = id + '-' + Math.random().toString(36).slice(2, 11);
    var starId = 'star-' + uniqueId;
    var halfStarMaskId = 'half-star-mask-' + uniqueId;
    var ratingLabel = 'Rating: ' + rating.toFixed(1) + ' out of 5';
    var countHtml = reviewCount != null && !isNaN(Number(reviewCount)) && reviewCount >= 0
      ? '<span class="review-count">(' + Math.round(Number(reviewCount)) + ')</span>'
      : '';
    var defs = '<svg class="visually-hidden" style="width:0;height:0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true">' +
      '<defs>' +
      '<symbol id="' + starId + '" viewBox="0 0 32 32"><path d="' + STAR_PATH + '"/></symbol>' +
      '</defs></svg>';
    var starsHtml = '';
    var i;
    for (i = 0; i < full; i++) {
      starsHtml += '<svg class="stars filled-star" viewBox="0 0 32 32" role="presentation" style="fill:#ff8d00">' +
        '<use href="#' + starId + '" fill="#ff8d00"></use></svg>';
    }
    if (half) {
      starsHtml += buildHalfStarSvg(halfStarMaskId);
    }
    for (i = 0; i < empty; i++) {
      starsHtml += '<svg class="stars" viewBox="0 0 32 32" role="presentation" style="fill:#bbbbbb">' +
        '<use href="#' + starId + '" fill="#bbbbbb"></use></svg>';
    }
    return '<div class="missed-auction-card__rating">' +
      '<div class="review-block rating-wrapper rating-color--primary">' +
      defs +
      '<div class="review-block__top-row">' +
      '<div class="rating" style="--star-size:17px" aria-label="' + String(ratingLabel).replace(/"/g, '&quot;') + '">' +
      starsHtml +
      '</div></div>' +
      countHtml +
      '</div></div>';
  }

  /**
   * Installment count for the Budget Pay line on a tab card, or 0 when the item has no offer.
   *
   * AMS only fills offerBudgetPay/numberOfEMI on the last-24-items and best-buys feeds — the
   * last-24-hours schedule feed returns offerBudgetPay:false / numberOfEMI:0 on every row and
   * carries the real count in bpemiCount alone. bpemiCount is therefore the one field all three
   * tabs agree on; where both are populated it equals numberOfEMI exactly, so reading it first
   * leaves the items/best-buys tabs unchanged and lights up the hours tab. offerBudgetPay is
   * deliberately not used as a veto for the same reason. Counts below 2 are not an offer
   * ("Or 1 x Payments" is not a thing).
   */
  function budgetPayInstallmentCount(item) {
    if (!item) return 0;
    var candidates = [item.bpemiCount, item.numberOfEMI];
    for (var ci = 0; ci < candidates.length; ci++) {
      var count = parseInt(candidates[ci], 10);
      if (!isNaN(count) && count > 1) return count;
    }
    return 0;
  }

  /**
   * AMS price of an auction row as a string for `data-line-price`, or '' when it has none.
   * The live feed sends `currentPrice`; the missed-auction feeds send `price`.
   */
  function amsRowPrice(row) {
    if (!row) return '';
    var raw = row.currentPrice != null ? row.currentPrice
      : row.CurrentPrice != null ? row.CurrentPrice
      : row.price != null ? row.price
      : row.Price;
    var n = Number(raw);
    return isFinite(n) && n > 0 ? String(n) : '';
  }

  function buildCard(item, cardIndex, sectionId, quantityErrorMax, moneyFormat, quantityLimit, soldOutSuffix, allowEager) {
    soldOutSuffix = soldOutSuffix != null && String(soldOutSuffix) !== '' ? String(soldOutSuffix) : ' (sold out)';
    moneyFormat = moneyFormat || '£{{amount}}';
    var gridEl = document.querySelector('[data-budget-pay-icon]');
    var budgetPayIcon =  gridEl &&  gridEl.getAttribute('data-budget-pay-icon') ? gridEl.getAttribute('data-budget-pay-icon') : '';
    var qtyMax = (quantityLimit != null && quantityLimit !== '') ? parseInt(quantityLimit, 10) : 99;
    if (isNaN(qtyMax) || qtyMax < 1) qtyMax = 99;
    var sd = item.shopifyData;
    var gridEl = document.querySelector('[data-show-wishlist]');
    var showWishlist = gridEl && gridEl.getAttribute('data-show-wishlist') === 'true';

    var title = (sd && sd.productName && String(sd.productName).trim()) || (item.itemName || item.item_name || '').trim() || ('Item ' + (item.stockCode || item.auctionCode || ''));
    /* AMS is the price of record for an auction; the Shopify catalogue price is only a fallback. */
    var amsItemPrice = Number(item.price != null ? item.price : item.currentPrice);
    var price = (isFinite(amsItemPrice) && amsItemPrice > 0)
      ? amsItemPrice
      : ((sd && sd.productPrice != null && sd.productPrice !== '') ? sd.productPrice : 0);
    var searchQ = encodeURIComponent((item.stockCode || item.itemName || title).toString());
    var productUrlRaw = (sd && sd.productUrl && String(sd.productUrl).trim()) ? String(sd.productUrl).trim() : '';
    var productUrl = productUrlRaw.replace(/"/g, '&quot;');
    var rawVariantId = (sd && sd.variantId) ? String(sd.variantId) : (sd && sd.shopifyVariantId) ? String(sd.shopifyVariantId) : '';
    var variantId = normalizeVariantId(rawVariantId);
    var href = productUrlRaw
      ? productUrlWithVariant(productUrlRaw, variantId).replace(/"/g, '&quot;')
      : ('/search?q=' + searchQ);
    var mediaCount = (sd && sd.productMedia && Array.isArray(sd.productMedia)) ? Math.min(sd.productMedia.length, 5) : 0;
    var imgHtml;
    if (mediaCount > 0 && sd.productMedia[0]) {
      /* Only the first row of cards can be the LCP element, so only those are eager — and
         only when this grid actually starts above the fold. On /pages/livetv the grid sits
         below the video, and marking four off-screen images fetchpriority="high" took LCP
         from 5,639 ms to 8,547 ms on staging by competing with the real LCP resource for
         bandwidth. The hover image is never visible on first paint and always stays lazy. */
      var eagerPrimary = allowEager && cardIndex < LTV_EAGER_CARD_COUNT;
      imgHtml = ltvImgTag(sd.productMedia[0], {
        eager: eagerPrimary,
        sizes: LTV_CARD_IMG_SIZES,
        className: 'missed-auction-card__img',
        extra: 'data-gallery-primary'
      });
      if (mediaCount >= 2 && sd.productMedia[1]) {
        imgHtml += ltvImgTag(sd.productMedia[1], {
          sizes: LTV_CARD_IMG_SIZES,
          className: 'missed-auction-card__img missed-auction-card__img-hover',
          extra: 'data-gallery-hover aria-hidden="true"'
        });
      }
    } else {
      mediaCount = 0;
      imgHtml = liveTvMissedPlaceholderHtml(allowEager && cardIndex < LTV_EAGER_CARD_COUNT);
    }

    var wishlistHtml = '';
    if (showWishlist && sd.productId && sd.productUrl) {
      var productHandle = sd.productUrl.replace('/products/', '').split('?')[0];
      var numericProductId = String(sd.productId).split('/').pop();
      var primaryImageUrl = '';
      if (sd.productMedia && Array.isArray(sd.productMedia) && sd.productMedia.length > 0) {
        primaryImageUrl = sd.productMedia[0];
      }
      var currentPrice = sd.productPrice || '';
      var compareAtPrice = sd.compareAtPrice || '';
      wishlistHtml =
      '<div class="missed-auction-card__wishlist">' +
        '<button ' +
          'type="button" ' +
          'class="wishlist-icon" ' +
          'data-wishlist-toggle ' +
          'data-product-id="' + numericProductId + '" ' +
          'data-product-handle="' + productHandle + '" ' +
          'data-product-title="' + String(title).replace(/"/g, '&quot;') + '" ' +
          'data-product-url="' + href + '" ' +
          'data-product-image="' + String(primaryImageUrl).replace(/"/g, '&quot;') + '" ' +
          'data-product-price="' + currentPrice + '" ' +
          'data-product-compare-at-price="' + compareAtPrice + '" ' +
          'data-selected-variant-id="' + variantId + '" ' +
          'data-selected-variant-sku="' + String(item.stockCode || '').replace(/"/g, '&quot;') + '" ' +
          'data-wishlist-context="live-tv"' +
          'aria-label="Add to wishlist"' +
        '>' +
          '<span class="wishlist-icon__svg">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
              '<path class="wishlist-icon__heart" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
            '</svg>' +
          '</span>' +
        '</button>' +
      '</div>';
    }
    var formId = 'MissedAuctionForm-js-' + (cardIndex != null ? cardIndex : Math.random().toString(36).slice(2, 9));
    var variantIdBySku = item.variantIdBySku || (sd && sd.variantIdBySku) || {};
    var variantSizeBySku = (sd && sd.variantSizeBySku) || {};
    var groupauctions = item.groupauctions || item.groupAuctions || [];
    groupauctions = sortAuctionItemsByDisplaySize(groupauctions, variantSizeBySku);
    var isBuyAllFlag = item.isBuyAll === true || item.isBuyAllAvailable === true;
    var availableCount = countAvailableGroupVariants(groupauctions);
    var isBuyAll = isBuyAllFlag && availableCount >= 2;
    var ringResize = liveTvRingResizeFromShopifyData(sd, groupauctions);
    if (ringResize) isBuyAll = false;
    var buyAllPrice = item.buyAllPrice != null ? Number(item.buyAllPrice) : 0;
    var buyAllDiscount = item.buyAllDiscount != null ? Number(item.buyAllDiscount) : 0;
    var discountCode = (item.discountCode != null || item.DiscountCode != null) ? String(item.discountCode != null ? item.discountCode : item.DiscountCode).trim() : '';
    var auctionCode = (item.auctionCode != null || item.AuctionCode != null) ? String(item.auctionCode != null ? item.auctionCode : item.AuctionCode).trim() : '';
    var maPnp = item.shippingCharges != null ? item.shippingCharges : item.ShippingCharges != null ? item.ShippingCharges : '';

    var dropdownsHtml = '';
    if (!ringResize && hasGlaMla(item)) {
      /* Same flat list the GLA change handler falls back to when a row has no nested mlauctions. */
      var itemMlaAuctions = item.mlaAuctions || item.MLAAuctions || [];
      if (!Array.isArray(itemMlaAuctions)) itemMlaAuctions = [];
      var configJson = JSON.stringify({ groupauctions: groupauctions, variantIdBySku: variantIdBySku, variantSizeBySku: variantSizeBySku }).replace(/<\//g, '<\\/');
      dropdownsHtml =
        '<script type="application/json" id="' + formId + '-gla-mla-config">' + configJson + '</script>' +
        '<div class="missed-auction-card__form-row missed-auction-card__form-row--dropdowns" data-gla-mla-form data-form-id="' + formId + '">' +
        '<div class="missed-auction-card__select-wrap">' +
        '<label for="' + formId + '-gla" class="visually-hidden">Select</label>' +
        '<select id="' + formId + '-gla" class="missed-auction-card__select" aria-label="Select" data-gla-select required>' +
        '<option value="" selected>Select</option>';
      for (var g = 0; g < groupauctions.length; g++) {
        var gla = groupauctions[g];
        var glaCode = (gla.auctionCode || gla.AuctionCode || '').toString().trim();
        var glaSku = String(gla.stockCode || gla.StockCode || '').trim();
        var dataStockCodeAttr = glaSku ? ' data-stock-code="' + String(glaSku).replace(/"/g, '&quot;') + '"' : '';
        var glaPnp = pnpFromAuctionJson(gla);
        var dataPnpAttr = glaPnp ? ' data-pnp="' + String(glaPnp).replace(/"/g, '&quot;') + '"' : '';
        var glaLinePrice = amsRowPrice(gla);
        var dataGlaLinePriceAttr = glaLinePrice ? ' data-line-price="' + glaLinePrice + '"' : '';
        var glaSold = glaOptionSoldOut(gla, sd && sd.inventoryBySku, itemMlaAuctions, variantSizeBySku);
        var glaLabelHtml = String(getLabel(gla)).replace(/</g, '&lt;') + (glaSold ? String(soldOutSuffix).replace(/</g, '&lt;') : '');
        var glaDis = glaSold ? ' disabled' : '';
        dropdownsHtml +=
          '<option value="' +
          String(glaCode).replace(/"/g, '&quot;') +
          '" data-auction-code="' +
          String(glaCode).replace(/"/g, '&quot;') +
          '"' +
          dataStockCodeAttr +
          dataPnpAttr +
          dataGlaLinePriceAttr +
          glaDis +
          '>' +
          glaLabelHtml +
          '</option>';
      }
      dropdownsHtml +=
        '</select>' +
        '</div>' +
        '<div class="missed-auction-card__select-wrap">' +
        '<label for="' + formId + '-mla" class="visually-hidden">Select option</label>' +
        '<select id="' + formId + '-mla" class="missed-auction-card__select missed-auction-card__select--disabled" aria-label="Select option" required data-mla-select data-placeholder="Select">' +
        '<option value=""  selected>Select</option>' +
        '</select>' +
        '</div>' +
        '</div>';
    } else if (ringResize || hasGlaOnly(item)) {
      var buyAllSkus = [];
      var buyAllAuctionCodes = [];
      for (var vi = 0; vi < groupauctions.length; vi++) {
        var row = groupauctions[vi];
        var gasku = getStockCode(row);
        if (!gasku || isGroupAuctionBuyAllSku(gasku)) continue;
        if (amsGroupRowQuantity(row) <= 0) continue;
        buyAllSkus.push(gasku);
        var ac = row.auctionCode != null ? row.auctionCode : (row.AuctionCode != null ? row.AuctionCode : '');
        buyAllAuctionCodes.push(String(ac).trim());
      }
      var buyAllCodesAttr = '';
      if (isBuyAll && buyAllAuctionCodes.length > 0 && buyAllAuctionCodes.length === buyAllSkus.length) {
        buyAllCodesAttr = ' data-buy-all-auction-codes="' + buyAllAuctionCodes.join(',').replace(/"/g, '&quot;') + '"';
      }
      var buyAllPnps = [];
      for (var pi = 0; pi < groupauctions.length; pi++) {
        var prow = groupauctions[pi];
        var psku = getStockCode(prow);
        if (!psku || isGroupAuctionBuyAllSku(psku)) continue;
        if (amsGroupRowQuantity(prow) <= 0) continue;
        var pp = pnpFromAuctionJson(prow);
        buyAllPnps.push(pp || '');
      }
      var buyAllPnpAttr = '';
      if (isBuyAll && buyAllPnps.length > 0 && buyAllPnps.length === buyAllSkus.length) {
        buyAllPnpAttr = ' data-buy-all-pnp="' + buyAllPnps.join(',').replace(/"/g, '&quot;') + '"';
      }
      var buyAllSkusAttr = isBuyAll && buyAllSkus.length > 0
        ? ' data-buy-all-skus="' + buyAllSkus.join(',').replace(/"/g, '&quot;') + '"' + buyAllCodesAttr + buyAllPnpAttr + ' data-buy-all-api-url="/apps/live-tv/buy-all-variants"'
        : '';
      var ringResizeRowAttrs = ringResize
        ? ' data-ring-resize-form data-ring-resize-master-sku="' + String(ringResize.masterSku).replace(/"/g, '&quot;') + '" data-ring-resize-master-available="' + (ringResize.masterAvailable ? 'true' : 'false') + '"'
        : '';
      dropdownsHtml =
        '<div class="missed-auction-card__form-row missed-auction-card__form-row--dropdowns"' + buyAllSkusAttr + ringResizeRowAttrs + '>' +
        '<div class="missed-auction-card__select-wrap">' +
        '<label for="' + formId + '-variant" class="visually-hidden">Select</label>' +
        '<select id="' + formId + '-variant" class="missed-auction-card__select" aria-label="Select" data-variant-select required>' +
        '<option value="">Select</option>';
      for (var v = 0; v < groupauctions.length; v++) {
        var ga = groupauctions[v];
        var gaSku = getStockCode(ga);
        if (isGroupAuctionBuyAllSku(gaSku)) continue;
        var gaVariantId = (variantIdBySku && gaSku && variantIdBySku[gaSku] != null) ? String(variantIdBySku[gaSku]) : '';
        var gaSize = String(ga.ItemSize || ga.itemSize || ga.variant || ga.Variant || (variantSizeBySku && variantSizeBySku[gaSku]) || '').trim();
        var selected = (variantId && gaVariantId === variantId) ? ' selected' : '';
        var dataSkuAttr = gaSku ? ' data-sku="' + String(gaSku).replace(/"/g, '&quot;') + '"' : '';
        var gaPnpOnly = pnpFromAuctionJson(ga);
        var dataPnpGa = gaPnpOnly ? ' data-pnp="' + String(gaPnpOnly).replace(/"/g, '&quot;') + '"' : '';
        var gaLinePrice = amsRowPrice(ga);
        var dataGaLinePriceAttr = gaLinePrice ? ' data-line-price="' + gaLinePrice + '"' : '';
        /* Ring resize is decided per option, not per group. AMS stamps the flag on every resize
           variant, so a group row without it is a plain item: it keeps its own stock and must not
           carry _isRingResize. Only a flagged row is cut from the master ring. */
        var gaInvEnt = (sd && sd.inventoryBySku && gaSku) ? sd.inventoryBySku[gaSku] : null;
        var gaIsResize = !!(ringResize && gaInvEnt && gaInvEnt.ringResizer === true && gaInvEnt.resizeProductVariantId);
        /* Ring resize: the master ring is the physical stock — it governs every size option. */
        var gaSold = ringResize
          ? !ringResize.masterAvailable
          : liveTvSkuSoldOutFromInventoryBySku(sd && sd.inventoryBySku, gaSku);
        var ringResizeOptAttrs = '';
        if (ringResize) {
          var gaRowAc = String(ga.auctionCode != null ? ga.auctionCode : (ga.AuctionCode != null ? ga.AuctionCode : '')).trim();
          if (gaRowAc) ringResizeOptAttrs += ' data-auction-code="' + gaRowAc.replace(/"/g, '&quot;') + '"';
          if (gaIsResize && gaSku && gaSku !== ringResize.masterSku) {
            ringResizeOptAttrs +=
              ' data-ring-resize="true"' +
              ' data-resize-variant-id="' + String(ringResize.masterSku).replace(/"/g, '&quot;') + '"' +
              ' data-resize-new-size="' + String(gaSize).replace(/"/g, '&quot;') + '"' +
              ' data-resize-original-size="' + String(ringResize.masterSize).replace(/"/g, '&quot;') + '"';
          }
        }
        var gaLabelHtml = (gaSize ? gaSize.replace(/</g, '&lt;') + (gaSku ? ' (' + String(gaSku).replace(/</g, '&lt;') + ')' : '') : String(gaSku).replace(/</g, '&lt;')) + (gaSold ? String(soldOutSuffix).replace(/</g, '&lt;') : '');
        var gaDis = gaSold ? ' disabled' : '';
        dropdownsHtml +=
          '<option value="' +
          String(gaVariantId).replace(/"/g, '&quot;') +
          '"' +
          dataSkuAttr +
          dataPnpGa +
          dataGaLinePriceAttr +
          ringResizeOptAttrs +
          selected +
          gaDis +
          '>' +
          gaLabelHtml +
          '</option>';
      }
      if (isBuyAll) {
        var buyAllLabel = buyAllPrice > 0 ? ('Buy All (' + formatMoney(buyAllPrice, moneyFormat) + ')') : 'Buy All';
        dropdownsHtml += '<option value="buy-all" data-buy-all="true">' + String(buyAllLabel).replace(/</g, '&lt;') + '</option>';
      }
      dropdownsHtml +=
        '</select>' +
        '</div>' +
        '</div>';
    }

    var primarySku = String(item.stockCode || getStockCode(item) || '').trim();
    var ringResizeSoldOut = !!(ringResize && !ringResize.masterAvailable);
    var simpleSoldOut = ringResizeSoldOut || (!dropdownsHtml && liveTvSkuSoldOutFromInventoryBySku(sd && sd.inventoryBySku, primarySku));
    var storefrontUnavailable = !!(sd && sd.storefrontAvailable === false);
    var fixedStorefrontUnavailable = storefrontUnavailable && !dropdownsHtml;
    var addBtnLabel = simpleSoldOut ? 'Sold out' : 'Add To Bag';
    var addBtnDisabled = (simpleSoldOut || fixedStorefrontUnavailable) ? ' disabled' : '';
    var initialSoldOutAttr = simpleSoldOut ? ' data-initial-sold-out="true"' : '';
    /* A grouped card can switch to a SKU backed by a different product; its per-SKU map
       owns availability. The form-level flag is only for a simple, fixed product. */
    var storefrontUnavailableAttr = fixedStorefrontUnavailable
      ? ' data-storefront-unavailable="true"'
      : '';
    var qtyWrapHtml = (simpleSoldOut || fixedStorefrontUnavailable)
      ? ''
      : '<div class="missed-auction-card__quantity-wrap">' +
        '<label for="' + formId + '-qty" class="visually-hidden">Quantity</label>' +
        '<button type="button" class="missed-auction-card__qty-btn" data-qty-minus aria-label="Decrease quantity">−</button>' +
        '<input type="number" id="' + formId + '-qty" name="quantity" value="1" min="1" max="' + qtyMax + '" class="missed-auction-card__qty-input" aria-label="Quantity" readonly>' +
        '<button type="button" class="missed-auction-card__qty-btn" data-qty-plus aria-label="Increase quantity">+</button>' +
        '</div>';
    var qtyCtaHtml =
      '<div class="missed-auction-card__form-row missed-auction-card__form-row--qty-cta">' +
      qtyWrapHtml +
      '<button type="submit" name="add" class="missed-auction-card__cta missed-auction-card__cta--add"' + addBtnDisabled + initialSoldOutAttr + '><span class="missed-auction-card__cta-label">' + addBtnLabel + '</span>' +
      '<span class="add-to-cart-spinner" aria-hidden="true">' +
      '<svg class="add-to-cart-spinner__svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<circle class="add-to-cart-spinner__track" cx="10" cy="10" r="8" stroke="#FFFFFF" stroke-width="2" fill="none" stroke-opacity="0.3"/>' +
      '<circle class="add-to-cart-spinner__arc" cx="10" cy="10" r="8" stroke="#22A59A" stroke-width="2" fill="none" stroke-linecap="round"/>' +
      '</svg></span></button>' +
      '</div>';

    var averageRating = (sd && sd.averageRating != null && !isNaN(Number(sd.averageRating))) ? Number(sd.averageRating) : null;
    var reviewCount = (sd && sd.reviewCount != null && !isNaN(Number(sd.reviewCount))) ? Number(sd.reviewCount) : null;
    var budgetPayHtml = '';
    var budgetPayCount = budgetPayInstallmentCount(item);

    if (budgetPayCount > 0) {
      budgetPayHtml =
      '<div class="missed-auction-card__budget-pay">' +
        '<span class="missed-auction-card__budget-pay-text">Or</span>' +
        '<span class="missed-auction-card__budget-pay-count">' + budgetPayCount + '</span>' +
        '<span class="missed-auction-card__budget-pay-x">x</span>' +
        '<img ' + 'src="' + budgetPayIcon + '" ' + 'alt="Budget Pay" ' + 'class="missed-auction-card__budget-pay-icon"' + '>' +
        '<span class="missed-auction-card__budget-pay-label">' + 'Payments' + '</span>' +
      '</div>';
    }
    var ratingHtml = buildRatingHtml(averageRating, reviewCount, formId);

    var productId = (sd && sd.productId) ? String(sd.productId).replace(/"/g, '&quot;') : '';
    var sectionIdAttr = String(sectionId || '').replace(/"/g, '&quot;');
    var quantityErrorMaxAttr = String(quantityErrorMax || 'This item has a maximum of {{ maximum }}').replace(/"/g, '&quot;');
    var formWrapperOpen =
      '<product-form-component' +
      ' data-section-id="' + sectionIdAttr + '"' +
      ' data-product-id="' + productId + '"' +
      ' data-product-url="' + productUrl + '"' +
      ' data-source="live-tv"' +
      ' on:submit="/handleSubmit"' +
      ' data-quantity-default="1"' +
      ' data-quantity-error-max="' + quantityErrorMaxAttr + '"' +
      '>' +
      '<div class="visually-hidden" aria-live="assertive" role="status" aria-atomic="true" ref="liveRegion"></div>' +
      '<form action="/cart/add" method="post" id="' + formId + '" class="missed-auction-card__form" novalidate data-label-add="Add To Bag" data-label-sold-out="Sold out"' + storefrontUnavailableAttr + '>';
    var formWrapperClose = '</form></product-form-component>';

    var article = document.createElement('article');
    article.className = 'missed-auction-card';
    article.setAttribute('data-product-sku', item.stockCode || '');
    if (sd && sd.inventoryBySku && typeof sd.inventoryBySku === 'object') {
      try {
        article.setAttribute(
          'data-shopify-inventory',
          JSON.stringify({ inventoryBySku: sd.inventoryBySku }).replace(/"/g, '&quot;')
        );
      } catch (e) {}
    }
    if (sd && sd.productId) article.setAttribute('data-product-id', String(sd.productId));
    if (productUrlRaw) article.setAttribute('data-product-url', productUrlRaw);
    if (variantId) article.setAttribute('data-initial-variant-id', variantId);
    if (hasGlaMla(item) && groupauctions.length > 0) {
      try {
        article.setAttribute('data-groupauctions', JSON.stringify(groupauctions).replace(/"/g, '&quot;'));
      } catch (e) { }
    }
    var galleryDotsHtml = '';
    if (mediaCount > 1 && sd && sd.productMedia) {
      var galleryLabel = 'Image gallery';
      var imageLabel = 'Image';
      for (var di = 0; di < mediaCount; di++) {
        var dotSrc = sd.productMedia[di] ? String(sd.productMedia[di]).replace(/"/g, '&quot;') : '';
        var dotActive = di === 0 ? ' missed-auction-card__gallery-dot--active' : '';
        var ariaSel = di === 0 ? 'true' : 'false';
        galleryDotsHtml += '<button type="button" class="missed-auction-card__gallery-dot' + dotActive + '" role="tab" aria-selected="' + ariaSel + '" aria-label="' + imageLabel + ' ' + (di + 1) + '" data-gallery-dot data-index="' + di + '" data-src="' + dotSrc + '"></button>';
      }
      galleryDotsHtml = '<div class="missed-auction-card__gallery-dots" role="tablist" aria-label="' + galleryLabel + '">' + galleryDotsHtml + '</div>';
    }
    var galleryArrowsHtml = '';
    if (mediaCount > 1) {
      galleryArrowsHtml =
        '<button type="button" class="missed-auction-card__gallery-arrow missed-auction-card__gallery-arrow--prev" data-gallery-prev aria-label="Previous">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<button type="button" class="missed-auction-card__gallery-arrow missed-auction-card__gallery-arrow--next" data-gallery-next aria-label="Next">' +
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>';
    }
    var mediaDataAttrs = ' data-missed-auction-gallery data-media-count="' + mediaCount + '"';
    /* Static fallback for _buyAllApplicableProductCodes (mirrors data-buy-all-skus): the JS
       add-to-cart path recomputes this from the DOM at submit time, but if anything ever
       submits the form without going through that JS (theme's own form handling, timing),
       this hidden input keeps the value from silently disappearing like its siblings don't. */
    var buyAllApplicableCodesValue = Array.isArray(buyAllSkus) ? buyAllSkus.join(',') : '';
    var buyAllHiddenFields = isBuyAll
      ? '<input type="hidden" name="properties[_discountCode]" value="' + String(discountCode).replace(/"/g, '&quot;').replace(/</g, '&lt;') + '">' +
        '<input type="hidden" name="properties[_buyAllPrice]" value="' + buyAllPrice + '">' +
        '<input type="hidden" name="properties[_buyAllDiscount]" value="' + buyAllDiscount + '">' +
        '<input type="hidden" name="properties[_buyAllApplicableProductCodes]" value="' + String(buyAllApplicableCodesValue).replace(/"/g, '&quot;') + '">'
      : '';
    /* Ring resize: stamped on selection by live-tv-card-forms.js applyRingResizeFromSelectedOption. */
    var ringResizeHiddenFields = ringResize
      ? '<input type="hidden" name="properties[_isRingResize]" value="">' +
        '<input type="hidden" name="properties[_resizeProductVariantId]" value="">' +
        '<input type="hidden" name="properties[_resizeNewSize]" value="">' +
        '<input type="hidden" name="properties[_resizeOriginalSize]" value="">'
      : '';
    article.innerHTML =
      '<div class="missed-auction-card__inner">' +
      '<div class="missed-auction-card__product-row">' +
      '<div class="missed-auction-card__media"' + mediaDataAttrs + '>' + wishlistHtml +
      '<a href="' + href + '" class="missed-auction-card__media-link">' +
      imgHtml +
      '</a>' +
      galleryArrowsHtml +
      galleryDotsHtml +
      '</div>' +
      '<div class="missed-auction-card__details">' +
      '<div class="missed-auction-card__info-block">' +
      '<h3 class="missed-auction-card__title">' +
      '<a href="' + href + '">' + String(title).replace(/</g, '&lt;').substring(0, 100) + (title.length > 100 ? '…' : '') + '</a>' +
      '</h3>' +
      (ratingHtml || '') +
      airSlotHtml(item) +
      '</div>' +
      '<div class="missed-auction-card__price-block">' +
      '<div class="missed-auction-card__price-row">' +
      '<span class="missed-auction-card__price qwertyu">' + formatMoney(price, moneyFormat) + '</span>' +
      '</div>' +
      budgetPayHtml +
      '</div>' +
      '</div>' +
      '</div>' +
      formWrapperOpen +
      '<input type="hidden" name="id" value="' + String(variantId).replace(/"/g, '&quot;') + '" data-current-variant-id ref="variantId">' +
      '<input type="hidden" name="properties[_itemSource]" value="MA">' +
      '<input type="hidden" name="properties[_pnp]" value="' + String(maPnp !== '' && maPnp != null ? maPnp : '').replace(/"/g, '&quot;') + '">' +
      '<input type="hidden" name="properties[_auctionCode]" value="' + String(auctionCode).replace(/"/g, '&quot;').replace(/</g, '&lt;') + '">' +
      '<input type="hidden" name="properties[_isBuyAll]" value="' + (isBuyAll ? 'true' : 'false') + '">' +
      buyAllHiddenFields +
      ringResizeHiddenFields +
      dropdownsHtml +
      qtyCtaHtml +
      formWrapperClose +
      '</div>';
    if (hasGlaMla(item) && groupauctions.length > 0) {
      var formEl = article.querySelector('form.missed-auction-card__form');
      if (formEl) {
        var configScript = document.createElement('script');
        configScript.type = 'application/json';
        configScript.id = formId + '-gla-mla-config';
        configScript.textContent = JSON.stringify({ groupauctions: groupauctions, variantIdBySku: variantIdBySku, variantSizeBySku: variantSizeBySku });
        formEl.insertBefore(configScript, formEl.firstChild);
      }
    }
    return article;
  }

  function initCardForm(cardEl, opts) {
    opts = opts || {};
    var glaMlaOnly = opts.glaMlaOnly === true;
    if (!cardEl) return;
    if (glaMlaOnly && cardEl.dataset.glaMlaInited === 'true') return;
    if (!glaMlaOnly && cardEl.dataset.missedAuctionFormInited === 'true') return;
    var form = cardEl.querySelector('form.missed-auction-card__form') || cardEl.querySelector('form.currently-on-air-card__form');
    if (!form) return;
    var hiddenId = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('.missed-auction-card__qty-input');
    var minusBtn = form.querySelector('[data-qty-minus]');
    var plusBtn = form.querySelector('[data-qty-plus]');
    var glaSelect = form.querySelector('[data-gla-select]');
    var mlaSelect = form.querySelector('[data-mla-select]');
    var variantSelect = form.querySelector('[data-variant-select]');
    var glaMlaRow = form.querySelector('[data-gla-mla-form]');

    function isInvalidSelection(select) {
      if (!select) return true;
      if (!select.options || select.options.length === 0) return true;
      var idx = select.selectedIndex;
      if (idx < 0) return true;
      if (idx > 0) return false;
      var opt = select.options[idx];
      var v = (opt && opt.value != null ? String(opt.value).trim() : (select.value || '').trim());
      return v === '' || v === 'Select';
    }
    form.addEventListener('submit', function (ev) {
      var addButton = form.querySelector('button[type="submit"][name="add"]');
      if (addButton && addButton.disabled) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        return;
      }
      if (glaMlaRow && glaSelect && mlaSelect) {
        if (isInvalidSelection(glaSelect)) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          glaSelect.classList.add('invalid-selection');
          return;
        }
        if (!mlaSelect.disabled && isInvalidSelection(mlaSelect)) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          mlaSelect.classList.add('invalid-selection');
          return;
        }
      } else if (variantSelect && isInvalidSelection(variantSelect)) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        variantSelect.classList.add('invalid-selection');
        return;
      }
    }, true);

    if (!glaMlaOnly) {
    }

    var gallery = cardEl.querySelector('[data-missed-auction-gallery]');
    if (!glaMlaOnly && gallery) {
      gallery.addEventListener('click', function (e) {
        var dot = e.target.closest && e.target.closest('[data-gallery-dot]');
        var prevBtn = e.target.closest && e.target.closest('[data-gallery-prev]');
        var nextBtn = e.target.closest && e.target.closest('[data-gallery-next]');
        var link = gallery.querySelector('.missed-auction-card__media-link');
        var primaryImg = link && link.querySelector('[data-gallery-primary]');
        var hoverImg = link && link.querySelector('[data-gallery-hover]');
        var dots = gallery.querySelectorAll('[data-gallery-dot]');
        var dotCount = dots.length;
        if (prevBtn || nextBtn) {
          if (dotCount === 0) return;
          e.preventDefault();
          e.stopPropagation();
          var activeDot = gallery.querySelector('.missed-auction-card__gallery-dot--active');
          var currentIndex = activeDot ? (parseInt(activeDot.getAttribute('data-index'), 10) || 0) : 0;
          var targetIndex = nextBtn ? (currentIndex + 1) % dotCount : (currentIndex - 1 + dotCount) % dotCount;
          dot = dots[targetIndex];
        }
        if (!dot) return;
        e.preventDefault();
        e.stopPropagation();
        var src = dot.getAttribute('data-src');
        if (!src || !primaryImg) return;
        ltvSetImgSrc(primaryImg, src);
        if (hoverImg && dotCount > 1) {
          var i = parseInt(dot.getAttribute('data-index'), 10) || 0;
          var nextIndex = (i + 1) % dotCount;
          var nextDot = dots[nextIndex];
          if (nextDot) ltvSetImgSrc(hoverImg, nextDot.getAttribute('data-src') || src);
        }
        for (var d = 0; d < dots.length; d++) {
          dots[d].classList.remove('missed-auction-card__gallery-dot--active');
          dots[d].setAttribute('aria-selected', dots[d] === dot ? 'true' : 'false');
        }
        dot.classList.add('missed-auction-card__gallery-dot--active');
        var clickedControl = prevBtn || nextBtn || dot;
        if (clickedControl && typeof clickedControl.blur === 'function') clickedControl.blur();
      });
    }

    function rebuildGallery(mediaEl, mediaUrls) {
      if (!mediaEl || !Array.isArray(mediaUrls)) return;
      var link = mediaEl.querySelector('.missed-auction-card__media-link');
      if (!link) return;
      var count = Math.min(mediaUrls.length, 5);
      mediaEl.setAttribute('data-media-count', count);
      if (count === 0) {
        link.innerHTML = liveTvMissedPlaceholderHtml();
        var oldDots = mediaEl.querySelector('.missed-auction-card__gallery-dots');
        if (oldDots) oldDots.remove();
        return;
      }
      var primaryUrl = mediaUrls[0];
      var linkHtml = ltvImgTag(primaryUrl, {
        sizes: LTV_CARD_IMG_SIZES,
        className: 'missed-auction-card__img',
        extra: 'data-gallery-primary'
      });
      if (count >= 2 && mediaUrls[1]) {
        linkHtml += ltvImgTag(mediaUrls[1], {
          sizes: LTV_CARD_IMG_SIZES,
          className: 'missed-auction-card__img missed-auction-card__img-hover',
          extra: 'data-gallery-hover aria-hidden="true"'
        });
      }
      link.innerHTML = linkHtml;
      var oldDots = mediaEl.querySelector('.missed-auction-card__gallery-dots');
      if (oldDots) oldDots.remove();
      if (count > 1) {
        var galleryLabel = 'Image gallery';
        var imageLabel = 'Image';
        var dotsHtml = '';
        for (var di = 0; di < count; di++) {
          var dotSrc = (mediaUrls[di] || '').replace(/"/g, '&quot;');
          var dotActive = di === 0 ? ' missed-auction-card__gallery-dot--active' : '';
          dotsHtml += '<button type="button" class="missed-auction-card__gallery-dot' + dotActive + '" role="tab" aria-selected="' + (di === 0 ? 'true' : 'false') + '" aria-label="' + imageLabel + ' ' + (di + 1) + '" data-gallery-dot data-index="' + di + '" data-src="' + dotSrc + '"></button>';
        }
        var dotsWrap = document.createElement('div');
        dotsWrap.className = 'missed-auction-card__gallery-dots';
        dotsWrap.setAttribute('role', 'tablist');
        dotsWrap.setAttribute('aria-label', galleryLabel);
        dotsWrap.innerHTML = dotsHtml;
        mediaEl.appendChild(dotsWrap);
      }
    }

    /**
     * Sync hidden variant id with the selected size. Empty / buy-all / Select
     * MUST clear a previous size's id — otherwise UI can show P while cart has M.
     */
    function setVariantId(val) {
      if (!hiddenId) {
        syncCardProductLinks(cardEl, form);
        return '';
      }
      var raw = val != null ? String(val).trim() : '';
      if (!raw || raw === 'buy-all' || raw === 'Select') {
        hiddenId.value = '';
        syncCardProductLinks(cardEl, form);
        return '';
      }
      var nid = normalizeVariantId(raw);
      hiddenId.value = nid;
      syncCardProductLinks(cardEl, form);
      return nid;
    }

    function isSkuStillSelected(select, expectedSku, expectedOpt) {
      if (!select || expectedSku == null || expectedSku === '') return true;
      var cur = select.options[select.selectedIndex];
      if (expectedOpt && cur !== expectedOpt) return false;
      var curSku = cur && cur.getAttribute('data-sku');
      return !curSku || String(curSku) === String(expectedSku);
    }

    function fillVariantIdFromSkuData(opt, select, expectedSku, variantId) {
      if (!hiddenId || !variantId) return;
      if (!isSkuStillSelected(select, expectedSku, opt)) return;
      var nid = normalizeVariantId(variantId);
      if (!nid) return;
      if (opt && (!opt.value || String(opt.value).trim() === '')) {
        opt.value = nid;
      }
      hiddenId.value = nid;
      hiddenId.setAttribute('data-current-variant-id', nid);
    }

    function syncMissedQtyBtnStates() {
      if (!qtyInput) return;
      var minQ = parseInt(qtyInput.getAttribute('min'), 10) || 1;
      var maxQ = qtyInput.hasAttribute('max') ? parseInt(qtyInput.getAttribute('max'), 10) : NaN;
      var v = parseInt(qtyInput.value, 10);
      if (minusBtn) minusBtn.classList.toggle('missed-auction-card__qty-btn--at-limit', v <= minQ);
      if (plusBtn) plusBtn.classList.toggle('missed-auction-card__qty-btn--at-limit', !isNaN(maxQ) && v >= maxQ);
    }

    if (!glaMlaOnly && qtyInput && minusBtn) {
      minusBtn.addEventListener('click', function () {
        var n = Math.max(1, parseInt(qtyInput.value, 10) - 1);
        qtyInput.value = n;
        syncMissedQtyBtnStates();
      });
    }
    if (!glaMlaOnly && qtyInput && plusBtn) {
      plusBtn.addEventListener('click', function () {
        var max = qtyInput.hasAttribute('max') ? parseInt(qtyInput.getAttribute('max'), 10) : NaN;
        var n = parseInt(qtyInput.value, 10) + 1;
        if (!isNaN(max)) n = Math.min(max, n);
        qtyInput.value = isNaN(n) ? 1 : n;
        syncMissedQtyBtnStates();
      });
    }
    if (!glaMlaOnly && qtyInput) syncMissedQtyBtnStates();

    if (!glaMlaOnly && variantSelect && hiddenId) {
      var formRowBuyAll = form.querySelector('[data-buy-all-skus]');
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        var rawVal = opt && opt.value != null ? String(opt.value).trim() : '';
        var lineAcVar = opt && opt.getAttribute('data-auction-code');
        var acInpVar = form.querySelector('input[name="properties[_auctionCode]"]');
        if (acInpVar && lineAcVar) acInpVar.value = lineAcVar;
        applyPnpFromOption(form, opt);
        /* Ring resize renders as this single dropdown, and this handler owns it on tab cards —
           stamp _isRingResize/_resize* here or the cart line (and AMS check-inventory) loses them. */
        if (typeof window.liveTvApplyRingResize === 'function') window.liveTvApplyRingResize(form, opt);
        if (rawVal === 'buy-all' && formRowBuyAll) {
          setVariantId('');
          formRowBuyAll.setAttribute('data-buy-all-variant-ids', '');
          var skus = (formRowBuyAll.getAttribute('data-buy-all-skus') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          var apiUrl = formRowBuyAll.getAttribute('data-buy-all-api-url') || '/apps/live-tv/buy-all-variants';
          if (skus.length) {
            fetch(apiUrl + '?skus=' + encodeURIComponent(skus.join(',')), { credentials: 'same-origin', headers: { 'Accept': 'application/json', 'ngrok-skip-browser-warning': 'true' } })
              .then(function (r) { return r.json(); })
              .then(function (json) {
                if (
                  !variantSelect.options[variantSelect.selectedIndex] ||
                  String(variantSelect.options[variantSelect.selectedIndex].value || '').trim() !== 'buy-all'
                ) return;
                var applyFn = window._liveTvApplyBuyAllVariantResponse;
                if (typeof applyFn === 'function') {
                  applyFn(variantSelect, formRowBuyAll, json);
                } else if (json && json.success && json.data && json.data.variants && json.data.variants.length) {
                  var idsLegacy = json.data.variants.map(function (v) { return v.variantId; }).filter(Boolean);
                  formRowBuyAll.setAttribute('data-buy-all-variant-ids', idsLegacy.join(','));
                }
                var idsStrApp = formRowBuyAll.getAttribute('data-buy-all-variant-ids');
                var idsParsed = (idsStrApp || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
                if (idsParsed[0]) setVariantId(idsParsed[0]);
                if (typeof window.liveTvSyncAddButtonState === 'function') window.liveTvSyncAddButtonState(form);
              })
              .catch(function () { });
          }
        } else {
          setVariantId(rawVal);
        }
        if (typeof window.liveTvSyncAddButtonState === 'function') window.liveTvSyncAddButtonState(form);
        var hadOptionId = !!(rawVal && rawVal !== 'buy-all');
        var sku = opt && opt.getAttribute && opt.getAttribute('data-sku');
        var optLinePriceRaw = opt && opt.getAttribute ? Number(opt.getAttribute('data-line-price')) : NaN;
        var optLinePrice = isFinite(optLinePriceRaw) && optLinePriceRaw > 0 ? optLinePriceRaw : null;
        if (optLinePrice != null && cardEl && rawVal !== 'buy-all') {
          var priceElNow = cardEl.querySelector('.missed-auction-card__price');
          var gridNow = cardEl.closest && cardEl.closest('[data-tab-items-grid]');
          if (priceElNow) priceElNow.textContent = formatMoney(optLinePrice, (gridNow && gridNow.getAttribute('data-money-format')) || '£{{amount}}');
        }
        if (sku && cardEl && rawVal !== 'buy-all') {
          var apiBase = (cardEl.closest && cardEl.closest('[data-tab-api-url]') && cardEl.closest('[data-tab-api-url]').getAttribute('data-tab-api-url')) || '/apps/live-tv/last-24-items';
          var skuDataUrl = apiBase.replace(/\/[^/]+$/, '') + '/sku-data?sku=' + encodeURIComponent(sku);
          fetch(skuDataUrl, { credentials: 'same-origin', headers: { 'ngrok-skip-browser-warning': 'true' } })
            .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
            .then(function (json) {
              if (!json || !json.success || !json.data) return;
              var d = json.data;
              /* Keep the option's own variant id when present — sku-data is a store-wide
                 lookup and duplicate skus would swap in another product's variant. */
              if (!hadOptionId && d.variantId) {
                fillVariantIdFromSkuData(opt, variantSelect, sku, d.variantId);
              }
              if (!isSkuStillSelected(variantSelect, sku, opt)) return;
              var productUrl = (d.productUrl && String(d.productUrl).trim()) ? d.productUrl : '';
              if (productUrl) {
                cardEl.setAttribute('data-product-url', productUrl);
                var pfc = form.closest('product-form-component');
                if (pfc) pfc.setAttribute('data-product-url', productUrl);
              }
              syncCardProductLinks(cardEl, form);
              var mediaEl = cardEl.querySelector('.missed-auction-card__media');
              var priceEl = cardEl.querySelector('.missed-auction-card__price');
              var titleEl = cardEl.querySelector('.missed-auction-card__title');
              if (mediaEl && d.productMedia !== undefined) {
                if (d.productMedia && d.productMedia.length > 0) {
                  rebuildGallery(mediaEl, d.productMedia);
                } else {
                  rebuildGallery(mediaEl, []);
                }
              }
              /* The option's AMS line price (painted above) wins over sku-data's Shopify catalogue price. */
              if (priceEl && optLinePrice == null && d.productPrice != null && d.productPrice !== '') {
                var grid = cardEl.closest && cardEl.closest('[data-tab-items-grid]');
                var moneyFmt = (grid && grid.getAttribute('data-money-format')) || '£{{amount}}';
                priceEl.textContent = formatMoney(d.productPrice, moneyFmt);
              }
              if (titleEl) {
                var titleLink = titleEl.querySelector('a');
                var name = (d.productName && String(d.productName).trim()) || titleEl.textContent || '';
                if (titleLink) {
                  titleLink.textContent = name.length > 100 ? name.substring(0, 100) + '…' : name;
                } else {
                  titleEl.textContent = name.length > 100 ? name.substring(0, 100) + '…' : name;
                }
              }
              if (typeof window.liveTvMergeSkuAvailability === 'function') window.liveTvMergeSkuAvailability(form, sku, d.availableForSale, d.storefrontAvailable);
              if (typeof window.liveTvMarkOptionSoldOut === 'function') window.liveTvMarkOptionSoldOut(form, opt, d.availableForSale);
              if (typeof window.liveTvSyncAddButtonState === 'function') window.liveTvSyncAddButtonState(form);
            })
            .catch(function () { });
        }
      });
      var firstOption = variantSelect.querySelector('option[value]:not([value=""]):not([disabled])');
      if (firstOption && firstOption.value && !hiddenId.value) setVariantId(firstOption.value);
    } else if (!glaMlaOnly && hiddenId && !glaSelect) {
      if (!hiddenId.value) {
        var initialId = cardEl.getAttribute('data-initial-variant-id');
        if (initialId) setVariantId(initialId);
      }
    }

    var formRowBuyAllIds = form.querySelector('[data-buy-all-skus]');
    if (!glaMlaOnly && formRowBuyAllIds) {
      form.addEventListener('submit', function (ev) {
        var select = form.querySelector('[data-variant-select]');
        if (select && select.value === 'buy-all') {
          ev.preventDefault();
          var buyAllVariantIdsStr = formRowBuyAllIds.getAttribute('data-buy-all-variant-ids');
          var ids = (buyAllVariantIdsStr || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          if (ids.length === 0) {
            console.log('Loading product data, please select Buy All again and try in a moment.');
            return;
          }
          var qty = (qtyInput && parseInt(qtyInput.value, 10)) || 1;
          var cartSkusAttr = formRowBuyAllIds.getAttribute('data-buy-all-cart-skus');
          var buyAllSkuListApp = (cartSkusAttr && String(cartSkusAttr).trim() !== ''
            ? cartSkusAttr
            : formRowBuyAllIds.getAttribute('data-buy-all-skus') || ''
          )
            .split(',')
            .map(function (s) { return s.trim(); })
            .filter(Boolean);
          var bulkAdd = window._liveTvPostBuyAllItemsToCart;
          if (typeof bulkAdd === 'function') {
            bulkAdd(form, formRowBuyAllIds, ids, qty, buyAllSkuListApp, false);
          } else {
            console.log('Cart could not load Buy All. Please refresh the page and try again.');
          }
        }
      }, true);
    }

    if (glaSelect && mlaSelect) {
      var formRow = form.querySelector('[data-gla-mla-form]');
      if (formRow && hiddenId) {
        try {
          var groupauctions = [];
          var mlaAuctions = [];
          var variantIdBySku = {};
          var variantSizeBySku = {};
          function applyGlaMlaConfig(parsed) {
            if (!parsed) return;
            var gas = parsed.groupauctions || parsed.groupAuctions || [];
            var mlas = parsed.mlaAuctions || parsed.MLAAuctions || [];
            if (gas.length) groupauctions = gas;
            if (mlas.length) mlaAuctions = mlas;
            if (parsed.variantIdBySku && Object.keys(parsed.variantIdBySku).length) {
              variantIdBySku = parsed.variantIdBySku;
            }
            if (parsed.variantSizeBySku && Object.keys(parsed.variantSizeBySku).length) {
              variantSizeBySku = parsed.variantSizeBySku;
            }
          }
          function readGlaMlaConfigJson() {
            function tryParse(el) {
              if (!el || !el.textContent) return null;
              try {
                return JSON.parse(el.textContent.trim());
              } catch (err) {
                return null;
              }
            }
            var origFid = formRow && formRow.getAttribute('data-form-id');
            var candidates = [
              form.querySelector('script[type="application/json"]'),
              cardEl.querySelector ? cardEl.querySelector('script[type="application/json"]') : null,
              document.getElementById((form.getAttribute('id') || '') + '-gla-mla-config'),
              origFid ? document.getElementById(origFid + '-gla-mla-config') : null
            ];
            var ci;
            var parsed;
            for (ci = 0; ci < candidates.length; ci++) {
              parsed = tryParse(candidates[ci]);
              if (parsed && ((parsed.groupauctions && parsed.groupauctions.length) || (parsed.groupAuctions && parsed.groupAuctions.length))) {
                return parsed;
              }
            }
            return tryParse(candidates[0]) || tryParse(candidates[3]);
          }
          if (cardEl.getAttribute('data-groupauctions')) {
            try {
              var rawAttr = (cardEl.getAttribute('data-groupauctions') || '').replace(/&quot;/g, '"');
              if (rawAttr) groupauctions = JSON.parse(rawAttr);
            } catch (e) { }
          }
          if (groupauctions.length === 0) {
            applyGlaMlaConfig(readGlaMlaConfigJson());
          }
          if (variantIdBySku && Object.keys(variantIdBySku).length === 0) {
            applyGlaMlaConfig(readGlaMlaConfigJson());
          }
          var invGridGlad = cardEl.closest && cardEl.closest('[data-tab-items-grid]');
          var soldOutGlad = (invGridGlad && invGridGlad.getAttribute('data-variant-sold-out-suffix')) || ' (sold out)';
          var invBySkuGlad = liveTvReadInventoryBySkuFromCard(cardEl);
          var moneyFormatEl = cardEl.closest('[data-money-format]');
          var cardMoneyFormat = moneyFormatEl ? moneyFormatEl.getAttribute('data-money-format') : '£{{amount}}';
          /** @see liveTvLinePriceOf in live-tv-card-forms.js — the auction's price for this SKU. */
          function linePriceOfOption(opt) {
            if (!opt || !opt.getAttribute) return null;
            var raw = opt.getAttribute('data-line-price');
            if (raw == null || String(raw).trim() === '') return null;
            var n = Number(raw);
            return isFinite(n) && n > 0 ? n : null;
          }
          function updateCardFromSkuData(d, skuVal, selOpt) {
            var mediaEl = cardEl.querySelector('.missed-auction-card__media') || cardEl.querySelector('.currently-on-air-card__media');
            var priceEl = cardEl.querySelector('.missed-auction-card__price') || cardEl.querySelector('.currently-on-air-card__price') || cardEl.querySelector('.view-details-popup__price');
            var titleEl = cardEl.querySelector('.missed-auction-card__title') || cardEl.querySelector('.currently-on-air-card__title') || cardEl.querySelector('.view-details-popup__product-title');
            var skuEl = cardEl.querySelector('.currently-on-air-card__sku') || cardEl.querySelector('.view-details-popup__sku') || cardEl.querySelector('.missed-auction-card__sku');
            var productMedia = d.productMedia || (d.shopifyData && d.shopifyData.productMedia);
            if (cardEl.classList && cardEl.classList.contains('view-details-popup') && typeof window.updateViewDetailsGalleryFromMedia === 'function' && productMedia !== undefined) {
              window.updateViewDetailsGalleryFromMedia(cardEl, Array.isArray(productMedia) ? productMedia : [], { productName: (d.productName && String(d.productName).trim()) || '' });
            } else if (mediaEl && productMedia !== undefined) {
              var link = mediaEl.querySelector('.missed-auction-card__media-link') || mediaEl.querySelector('.currently-on-air-card__media-link');
              var isCoaCard = !!cardEl.querySelector('.currently-on-air-card__media');
              var img = link && (link.querySelector('.missed-auction-card__img:not(.missed-auction-card__img-hover)') || link.querySelector('.currently-on-air-card__img:not(.currently-on-air-card__img-hover)') || link.querySelector('.currently-on-air-card__img'));
              var hoverImg = link && (link.querySelector('.missed-auction-card__img-hover') || link.querySelector('.currently-on-air-card__img-hover'));
              if (productMedia && Array.isArray(productMedia) && productMedia.length > 0) {
                var primaryUrl = typeof productMedia[0] === 'string' ? productMedia[0] : (productMedia[0] && productMedia[0].url);
                var secondUrl = productMedia.length >= 2 ? (typeof productMedia[1] === 'string' ? productMedia[1] : (productMedia[1] && productMedia[1].url)) : '';
                if (link && primaryUrl) {
                  if (isCoaCard && (!img || img.tagName !== 'IMG')) {
                    var coaHtml = ltvImgTag(primaryUrl, {
                      width: LTV_COA_IMG_WIDTH, boxWidth: 150, boxHeight: 150,
                      className: 'currently-on-air-card__img'
                    });
                    if (secondUrl) coaHtml += ltvImgTag(secondUrl, {
                      width: LTV_COA_IMG_WIDTH, boxWidth: 150, boxHeight: 150,
                      className: 'currently-on-air-card__img currently-on-air-card__img-hover',
                      extra: 'aria-hidden="true"'
                    });
                    link.innerHTML = coaHtml;
                  } else if (img && img.tagName === 'IMG') {
                    ltvSetImgSrc(img, primaryUrl, isCoaCard ? LTV_COA_IMG_WIDTH : LTV_CARD_IMG_WIDTH);
                    img.alt = (d.productName || '').trim() || '';
                  }
                  if (productMedia.length >= 2 && secondUrl) {
                    if (hoverImg && hoverImg.tagName === 'IMG') {
                      ltvSetImgSrc(hoverImg, secondUrl, isCoaCard ? LTV_COA_IMG_WIDTH : LTV_CARD_IMG_WIDTH);
                    } else if (isCoaCard && link && !link.querySelector('.currently-on-air-card__img-hover')) {
                      var coaHover = document.createElement('img');
                      ltvSetImgSrc(coaHover, secondUrl, LTV_COA_IMG_WIDTH);
                      coaHover.alt = '';
                      coaHover.width = 150;
                      coaHover.height = 150;
                      coaHover.loading = 'lazy';
                      coaHover.className = 'currently-on-air-card__img currently-on-air-card__img-hover';
                      coaHover.setAttribute('aria-hidden', 'true');
                      link.appendChild(coaHover);
                    }
                  } else if (hoverImg && isCoaCard) {
                    hoverImg.remove();
                  }
                  var dots = mediaEl.querySelectorAll('[data-gallery-dot]');
                  if (dots.length && productMedia[0]) dots[0].setAttribute('data-src', primaryUrl);
                }
              } else if (link) {
                link.innerHTML = isCoaCard ? liveTvCoaPlaceholderHtml() : liveTvMissedPlaceholderHtml();
              }
            }
            if (priceEl) {
              /* The selected auction line's price wins over sku-data's Shopify catalogue price. */
              var linePriceSel = linePriceOfOption(selOpt);
              if (linePriceSel != null) priceEl.textContent = formatMoney(linePriceSel, cardMoneyFormat);
              else if (d.productPrice != null && d.productPrice !== '') priceEl.textContent = formatMoney(d.productPrice, cardMoneyFormat);
            }
            if (titleEl && d.productName) {
              var titleLink = titleEl.querySelector('a');
              var name = String(d.productName).trim();
              var text = name.length > 100 ? name.substring(0, 100) + '\u2026' : name;
              if (titleLink) titleLink.textContent = text;
              else titleEl.textContent = text;
            }
            if (skuEl && skuVal !== undefined && skuVal !== '') {
              skuEl.textContent = skuVal;
            }
            var highlightsSku = cardEl.querySelector('[data-live-tv-highlights-sku]');
            if (highlightsSku && skuVal !== undefined && skuVal !== '') {
              highlightsSku.textContent = skuVal;
            }
            var highlightsAbout = cardEl.querySelector('[data-live-tv-highlights-about]');
            if (highlightsAbout && typeof d.highlightsHtml === 'string') {
              // Same source as live-tv-product-highlights.liquid: variant description, then product.
              highlightsAbout.innerHTML = d.highlightsHtml;
              var aboutWords = ltvHighlightsWordCount(d.highlightsHtml);
              var aboutSectionHtml = highlightsAbout.closest('.currently-on-air-card__accordion-section--about');
              if (aboutSectionHtml) aboutSectionHtml.hidden = aboutWords === 0;
              // Same rule as live-tv-product-highlights.liquid: under 40 words hides the whole section.
              var highlightsRootHtml = highlightsAbout.closest('[data-live-tv-highlights]');
              if (highlightsRootHtml) highlightsRootHtml.hidden = aboutWords < 40;
            } else if (highlightsAbout && d.productDescription != null && String(d.productDescription).trim() !== '') {
              var aboutText = String(d.productDescription).trim();
              highlightsAbout.textContent = aboutText;
              var aboutSection = highlightsAbout.closest('.currently-on-air-card__accordion-section--about');
              if (aboutSection) aboutSection.removeAttribute('hidden');
              // Same rule as live-tv-product-highlights.liquid: under 40 words hides the whole section.
              var highlightsRoot = highlightsAbout.closest('[data-live-tv-highlights]');
              if (highlightsRoot) highlightsRoot.hidden = aboutText.split(/\s+/).length < 40;
            }
            if (skuVal && cardEl) cardEl.setAttribute('data-product-sku', skuVal);
            var avgRating = d.averageRating != null ? d.averageRating : (d.shopifyData && d.shopifyData.averageRating != null ? d.shopifyData.averageRating : null);
            var revCount = d.reviewCount != null ? d.reviewCount : (d.shopifyData && d.shopifyData.reviewCount != null ? d.shopifyData.reviewCount : null);
            var ratingForm = cardEl.querySelector('form.missed-auction-card__form');
            var ratingUniqueId = ratingForm && ratingForm.id ? ratingForm.id : null;
            var ratingEl = cardEl.querySelector('.missed-auction-card__rating');
            if (ratingEl) {
              var newRatingHtml = buildRatingHtml(avgRating, revCount, ratingUniqueId);
              if (newRatingHtml) {
                var wrap = document.createElement('div');
                wrap.innerHTML = newRatingHtml;
                var newRatingNode = wrap.querySelector('.missed-auction-card__rating') || wrap.firstElementChild;
                if (newRatingNode && ratingEl.parentNode) {
                  ratingEl.parentNode.replaceChild(newRatingNode, ratingEl);
                }
              } else {
                ratingEl.innerHTML = '';
                ratingEl.style.display = 'none';
              }
            } else if (avgRating != null && (avgRating === avgRating)) {
              var infoBlock = cardEl.querySelector('.missed-auction-card__info-block');
              if (infoBlock) {
                var insertRating = buildRatingHtml(avgRating, revCount, ratingUniqueId);
                if (insertRating) {
                  var wrap = document.createElement('div');
                  wrap.innerHTML = insertRating;
                  var ratingNode = wrap.querySelector('.missed-auction-card__rating') || wrap.firstElementChild;
                  if (ratingNode) infoBlock.appendChild(ratingNode);
                }
              }
            }
            var url = (d.productUrl && String(d.productUrl).trim()) || (d.shopifyData && d.shopifyData.productUrl && String(d.shopifyData.productUrl).trim()) || '';
            if (url) {
              cardEl.setAttribute('data-product-url', url);
              var pfcSku = form.closest('product-form-component');
              if (pfcSku) pfcSku.setAttribute('data-product-url', url);
              syncCardProductLinks(cardEl, form);
            }
          }

          /** Paint the line price before the sku-data round-trip so the figure never lags the choice. */
          function applySelectedLinePriceNow(opt) {
            var lp = linePriceOfOption(opt);
            if (lp == null) return;
            var priceElNow = cardEl.querySelector('.missed-auction-card__price') || cardEl.querySelector('.currently-on-air-card__price') || cardEl.querySelector('.view-details-popup__price');
            if (priceElNow) priceElNow.textContent = formatMoney(lp, cardMoneyFormat);
          }

          glaSelect.addEventListener('change', function () {
            var sel = glaSelect.options[glaSelect.selectedIndex];
            var glaCode = String(glaSelect.value || (sel && sel.getAttribute('data-auction-code')) || '').trim();
            var glaSku = (sel && sel.getAttribute('data-stock-code')) || '';
            applySelectedLinePriceNow(sel);
            mlaSelect.innerHTML = '';
            mlaSelect.disabled = true;
            var mlaDisabledClass = mlaSelect.classList.contains('currently-on-air-card__select') ? 'currently-on-air-card__select--disabled' : 'missed-auction-card__select--disabled';
            mlaSelect.classList.add(mlaDisabledClass);
            var placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.selected = true;
            placeholder.textContent = mlaSelect.getAttribute('data-placeholder') || 'Select first';
            mlaSelect.appendChild(placeholder);
            if (hiddenId) hiddenId.value = '';
            syncCardProductLinks(cardEl, form);
            if (typeof window.liveTvSyncAddButtonState === 'function') window.liveTvSyncAddButtonState(form);
            if (!glaCode) return;
            if (groupauctions.length === 0) applyGlaMlaConfig(readGlaMlaConfigJson());
            var auctionCodeInpGla = form.querySelector('input[name="properties[_auctionCode]"]');
            if (auctionCodeInpGla) auctionCodeInpGla.value = glaCode;
            var selectedGroup = null;
            var optionText = (sel && sel.textContent) ? String(sel.textContent).trim().toLowerCase() : '';
            var glaCodeNorm = glaCode.toLowerCase();
            for (var i = 0; i < groupauctions.length; i++) {
              var ga = groupauctions[i];
              var code = String(ga && (ga.auctionCode != null || ga.AuctionCode != null) ? (ga.auctionCode != null ? ga.auctionCode : ga.AuctionCode) : '').trim();
              if (code.toLowerCase() === glaCodeNorm) { selectedGroup = ga; break; }
            }
            if (!selectedGroup && optionText) {
              for (var k = 0; k < groupauctions.length; k++) {
                var g = groupauctions[k];
                var sizeOrVariant = g && (g.ItemSize != null ? g.ItemSize : g.itemSize != null ? g.itemSize : g.variant != null ? g.variant : g.Variant);
                var v = sizeOrVariant ? String(sizeOrVariant).trim().toLowerCase() : '';
                if (v === optionText) { selectedGroup = g; break; }
              }
            }
            if (!selectedGroup) return;
            /* Includes the group row's own size — the same set glaOptionSoldOut gates the option on. */
            var mlauctions = sortAuctionItemsByDisplaySize(
              glaSizeRows(selectedGroup, mlaAuctions, variantSizeBySku),
              variantSizeBySku
            );
            /* The card map starts as a render-time snapshot and prefetch/sku-data merges refresh
               it after load, so re-read per rebuild instead of trusting the init-time read. */
            var invNowGlad = liveTvReadInventoryBySkuFromCard(cardEl) || invBySkuGlad;
            for (var j = 0; j < mlauctions.length; j++) {
              var mla = mlauctions[j];
              var sku = getStockCode(mla);
              var vid = variantIdBySku[sku] != null ? variantIdBySku[sku] : (sku && variantIdBySku[String(sku).trim()] != null) ? variantIdBySku[String(sku).trim()] : null;
              var mlaSize = String(mla.ItemSize || mla.itemSize || mla.variant || mla.Variant || (variantSizeBySku && variantSizeBySku[sku]) || '').trim();
              var label = mlaSize ? mlaSize + ' (' + sku + ')' : sku;
              /* Same predicate glaOptionSoldOut rolls up, so a parent option is only disabled
                 when every size it would offer here is disabled. */
              var mSold = auctionRowSoldOut(mla, invNowGlad);
              if (mSold) label += soldOutGlad;
              var opt = document.createElement('option');
              opt.value = vid != null ? String(vid) : '';
              if (sku) opt.setAttribute('data-sku', sku);
              var mlaPnpApp = pnpFromAuctionJson(mla);
              if (mlaPnpApp) opt.setAttribute('data-pnp', mlaPnpApp);
              var mlaLinePrice = amsRowPrice(mla);
              if (mlaLinePrice) opt.setAttribute('data-line-price', mlaLinePrice);
              var mlaLineAuctionCode = getMlaRowAuctionCode(mla);
              if (mlaLineAuctionCode) opt.setAttribute('data-auction-code', mlaLineAuctionCode);
              opt.textContent = label;
              opt.disabled = mSold;
              mlaSelect.appendChild(opt);
            }
            mlaSelect.disabled = false;
            mlaSelect.classList.remove(mlaDisabledClass);
            applyPnpFromOption(form, sel);
            if (typeof window.liveTvPrefetchOptionAvailability === 'function') window.liveTvPrefetchOptionAvailability(form, mlaSelect);

            if (glaSku) {
              var apiBase = (cardEl.closest && cardEl.closest('[data-tab-api-url]') && cardEl.closest('[data-tab-api-url]').getAttribute('data-tab-api-url')) || '/apps/live-tv/last-24-items';
              var skuDataUrl = apiBase.replace(/\/[^/]+$/, '') + '/sku-data?sku=' + encodeURIComponent(glaSku);
              fetch(skuDataUrl, { credentials: 'same-origin', headers: { 'ngrok-skip-browser-warning': 'true' } })
                .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
                .then(function (json) {
                  if (json && json.success && json.data) {
                    updateCardFromSkuData(json.data, glaSku, sel);
                    if (typeof window.liveTvMergeSkuAvailability === 'function') window.liveTvMergeSkuAvailability(form, glaSku, json.data.availableForSale, json.data.storefrontAvailable);
                    if (typeof window.liveTvSyncAddButtonState === 'function') window.liveTvSyncAddButtonState(form);
                  }
                })
                .catch(function () { });
            }
          });
          mlaSelect.addEventListener('change', function () {
            var opt = mlaSelect.options[mlaSelect.selectedIndex];
            var mlaLineAc = opt && opt.getAttribute('data-auction-code');
            var auctionCodeInpMla = form.querySelector('input[name="properties[_auctionCode]"]');
            if (auctionCodeInpMla && mlaLineAc) auctionCodeInpMla.value = mlaLineAc;
            var sku = opt && opt.getAttribute('data-sku');
            applySelectedLinePriceNow(opt);
            applyPnpFromOption(form, opt);
            /* Sync (or clear) immediately. Empty option values must not leave the prior
               size's id — that caused wrong size in basket (P selected, M added). */
            var val = setVariantId(opt && opt.value);
            if (sku && hiddenId) {
              var apiBase = (cardEl.closest && cardEl.closest('[data-tab-api-url]') && cardEl.closest('[data-tab-api-url]').getAttribute('data-tab-api-url')) || '/apps/live-tv/last-24-items';
              var skuDataUrl = apiBase.replace(/\/[^/]+$/, '') + '/sku-data?sku=' + encodeURIComponent(sku);
              fetch(skuDataUrl, { credentials: 'same-origin', headers: { 'ngrok-skip-browser-warning': 'true' } })
                .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
                .then(function (json) {
                  if (json && json.success && json.data) {
                    /* Only fill the variant id when the option had none (rebuilt options);
                       the store-wide sku lookup must not replace a config-resolved id. */
                    if (!val && json.data.variantId) {
                      fillVariantIdFromSkuData(opt, mlaSelect, sku, json.data.variantId);
                    }
                    if (!isSkuStillSelected(mlaSelect, sku, opt)) return;
                    updateCardFromSkuData(json.data, sku, opt);
                    if (typeof window.liveTvMergeSkuAvailability === 'function') window.liveTvMergeSkuAvailability(form, sku, json.data.availableForSale, json.data.storefrontAvailable);
                    if (typeof window.liveTvMarkOptionSoldOut === 'function') window.liveTvMarkOptionSoldOut(form, opt, json.data.availableForSale);
                    if (typeof window.liveTvSyncAddButtonState === 'function') window.liveTvSyncAddButtonState(form);
                  }
                })
                .catch(function () { });
            }
            if (typeof window.liveTvSyncAddButtonState === 'function') window.liveTvSyncAddButtonState(form);
          });
        } catch (e) { console.warn('Missed auction GLA/MLA init failed', e); }
      }
    }
    if (typeof window.liveTvSyncAddButtonState === 'function') {
      window.liveTvSyncAddButtonState(form);
    }
    syncCardProductLinks(cardEl, form);
    if (glaMlaOnly) cardEl.dataset.glaMlaInited = 'true';
    else cardEl.dataset.missedAuctionFormInited = 'true';
  }

  /* ---------------------------------------------------------------------------
   * Batched card rendering
   *
   * Building a card is expensive — markup, a form, a select, a star rating — and
   * `run()` used to build every one of them (up to cards_limit, default 96) inside
   * a single forEach. That was one 3,155 ms task on Live TV and 2,593 ms on Missed
   * Auctions: the longest task on either page, and the page is frozen for all of it.
   *
   * Work is now split across tasks. Two things drive it:
   *   - an IntersectionObserver on a trailing sentinel, which renders ahead of the
   *     scroll, and
   *   - an idle-callback chain, which drains the rest regardless.
   *
   * The chain is what makes this safe to rely on. A sentinel only works while it can
   * intersect the viewport, and these grids do not always allow that: the Best Buys
   * and Last 24 Hours panels start `hidden` and there is a dormant carousel rule
   * (`display:flex; overflow-x:auto`, style.css:2879) that would put the sentinel on
   * a horizontal axis a viewport-rooted observer cannot see. Observer-only, any of
   * those would silently drop every card past the first batch. The observer is an
   * accelerator; the idle chain is the guarantee.
   * ------------------------------------------------------------------------- */
  var GRID_BATCH_SIZE = 12;
  /** Slide/fade time when a refreshed list is swapped in (see reconcile()). */
  var GRID_SWAP_MS = 300;

  /** Stable id of a grid row, so a refreshed list can reuse the card already on screen. */
  function gridItemKey(item) {
    return String((item && (item.auctionCode || item.stockCode)) || '');
  }

  /* Wait (max 2.5 s) for each new card's main image, so a card never fades in empty and
     then pops its picture in. Cards are off screen here, so lazy images would never start. */
  function preloadCardImages(cards) {
    var waits = [];
    for (var i = 0; i < cards.length; i++) {
      var img = cards[i].querySelector('img');
      if (!img) continue;
      img.loading = 'eager';
      if (typeof img.decode === 'function') waits.push(img.decode().catch(function () {}));
    }
    if (!waits.length) return Promise.resolve();
    return Promise.race([
      Promise.all(waits),
      new Promise(function (resolve) { setTimeout(resolve, 2500); })
    ]);
  }

  var ltvRequestIdle =
    window.requestIdleCallback ||
    function (cb) { return setTimeout(function () { cb({ timeRemaining: function () { return 0; } }); }, 32); };
  var ltvCancelIdle = window.cancelIdleCallback || clearTimeout;

  /* ---------------------------------------------------------------------------
   * Grid space reservation
   *
   * The grid paints as one line of "Loading" text, then cards drop in and shove the
   * footer down the page. Measured with a layout-shift observer under Lighthouse's
   * mobile throttling, that footer move is 0.3196 of the 0.463 total on Missed
   * Auctions — by far the largest single shift on the page.
   *
   * Reservations are ordinary cards marked `--reserve`: laid out by the existing grid
   * and card rules, so exactly as tall as the real thing, but `visibility: hidden`, so
   * nothing new is painted. Real cards replace them one for one, which is what keeps
   * batched rendering from turning one shift into eight.
   *
   * How many to reserve is the whole problem — the count is only known once the fetch
   * lands. Reserving a fixed guess makes it worse: reserving 12 on a store that returns
   * 8 shrinks the grid by two rows and the footer jumps up. So:
   *   - before the fetch, reserve the count this grid rendered last time (remembered per
   *     grid in sessionStorage). First ever view has nothing to go on and still shifts
   *     once; every later view does not.
   *   - when the data lands, set the count to exactly what will render, in the same task
   *     as the first batch, so the grid reaches its final height in one step.
   * ------------------------------------------------------------------------- */

  function gridStubKey(grid) {
    return 'ltv:cards:' + (grid.getAttribute('data-tab-api-url') || '') + ':' + (grid.getAttribute('data-tab-type') || '');
  }

  /* ltvGridReserve — the parse-time half of the reservation.
   *
   * The stubs below cannot fix CLS on their own: app.js is `defer`, and on a page this size
   * the browser has painted long before it runs, so inserting stubs *is* the shift it was
   * meant to prevent. Measured on Missed Auctions, the footer shift stayed at 0.3937 with
   * stub reservation alone — the grid still jumped from one line of "Loading" to full
   * height, just later.
   *
   * So theme-extension-src/snippets/ltv-grid-reserve.liquid carries a small inline,
   * non-deferred script that applies `min-height` from the height recorded here on a previous
   * view. Inline because it has to run while the document is still parsing, and in a snippet
   * because both blocks need it. The theme Liquid build removes comment bodies and normalizes
   * line endings, but preserves indentation and all content whitespace so rendering cannot
   * change. Its code still counts against the 100 KB Liquid limit.
   *
   * First ever view is unchanged; every later view starts at the right height. render()
   * clears the inline floor in the same task that sets the exact stub count, so a drop in
   * auction count cannot leave the grid over-reserved.
   */
  function gridHeightKey(grid) {
    return 'ltv:gridh:' + (grid.getAttribute('data-tab-api-url') || '') + ':' + (grid.getAttribute('data-tab-type') || '');
  }

  function rememberGridHeight(grid) {
    try {
      var h = Math.round(grid.getBoundingClientRect().height);
      if (h > 0) window.sessionStorage.setItem(gridHeightKey(grid), String(h));
    } catch (e) { /* storage disabled */ }
  }

  function rememberGridCardCount(grid, count) {
    try {
      window.sessionStorage.setItem(gridStubKey(grid), String(count));
    } catch (e) { /* private mode / storage disabled — reservation is an optimisation only */ }
  }

  function recalledGridCardCount(grid) {
    try {
      var n = parseInt(window.sessionStorage.getItem(gridStubKey(grid)) || '', 10);
      return isNaN(n) || n < 0 ? 0 : n;
    } catch (e) { return 0; }
  }

  function makeReserveStub() {
    var stub = document.createElement('article');
    stub.className = 'missed-auction-card missed-auction-card--reserve';
    stub.setAttribute('aria-hidden', 'true');
    stub.innerHTML =
      '<div class="missed-auction-card__inner">' +
      '<div class="missed-auction-card__product-row">' +
      '<div class="missed-auction-card__media"><span class="missed-auction-card__media-link"></span></div>' +
      '<div class="missed-auction-card__reserve-text"></div>' +
      '</div></div>';
    return stub;
  }

  /** Grow or shrink the stub block to exactly `count`, keeping it before `before`. */
  function setGridStubCount(grid, count, before) {
    if (!grid) return;
    var stubs = grid.querySelectorAll('.missed-auction-card--reserve');
    if (stubs.length > count) {
      for (var i = count; i < stubs.length; i++) stubs[i].remove();
    } else if (stubs.length < count) {
      var frag = document.createDocumentFragment();
      for (var j = stubs.length; j < count; j++) frag.appendChild(makeReserveStub());
      if (before && before.parentNode === grid) grid.insertBefore(frag, before);
      else grid.appendChild(frag);
    }
    /* The "Loading" paragraph is a grid item, so while stubs are held it claims a cell and
       adds a whole extra row — measured 2,310px reserved against 1,838px of real cards, a
       472px overshoot that shows up as the footer snapping back up. The class lifts it out
       of flow for exactly as long as the reservation exists. */
    grid.classList.toggle('last-24-tabs__grid--reserving', count > 0);
  }

  /** Called before the fetch: hold whatever this grid needed last time. */
  function reserveFirstBatch(grid) {
    var limit = parseInt(grid.getAttribute('data-cards-limit') || '24', 10) || 24;
    var recalled = recalledGridCardCount(grid);
    if (recalled > 0) setGridStubCount(grid, Math.min(recalled, limit), null);
  }

  /* ---------------------------------------------------------------------------
   * Deferred card form wiring
   *
   * initCardForm() is the expensive half of building a card: variant select, quantity
   * controls, buy-all handling, gallery, price sync. Most cards are never touched, so
   * that work is moved off the render path.
   *
   * Correctness matters more than the saving here — a card whose form is not wired is a
   * card that cannot be added to the basket. Two things guarantee it is always ready:
   *
   *   1. A capture-phase listener on the grid. Capture runs before the event reaches the
   *      card, and it fires for non-bubbling events too, so the form is wired during the
   *      same gesture that will use it — a tap fires pointerdown long before submit.
   *   2. An idle sweep that wires whatever is left, in small chunks. Behaviour therefore
   *      converges on the old eager behaviour even if the shopper never interacts.
   *
   * initCardForm() is idempotent (it guards on data-missed-auction-form-inited), so the
   * two paths cannot double-wire a card.
   * ------------------------------------------------------------------------- */
  var LAZY_INIT_EVENTS = ['pointerdown', 'pointerenter', 'focusin', 'keydown', 'change', 'submit', 'click'];

  function initPendingCard(card) {
    if (!card || card.getAttribute('data-ltv-form-pending') !== '1') return;
    card.removeAttribute('data-ltv-form-pending');
    initCardForm(card);
  }

  function ensureLazyInitBinding(grid) {
    if (grid.__ltvLazyInitBound) return;
    grid.__ltvLazyInitBound = true;
    for (var i = 0; i < LAZY_INIT_EVENTS.length; i++) {
      grid.addEventListener(LAZY_INIT_EVENTS[i], function (e) {
        var card = e.target && e.target.closest ? e.target.closest('.missed-auction-card') : null;
        if (card) initPendingCard(card);
      }, true);
    }
  }

  /** Wire whatever the shopper has not touched, a few at a time, out of the critical path. */
  function sweepPendingCards(grid) {
    var pending = grid.querySelectorAll('.missed-auction-card[data-ltv-form-pending="1"]');
    if (!pending.length) return;
    for (var i = 0; i < pending.length && i < 4; i++) initPendingCard(pending[i]);
    ltvRequestIdle(function () { sweepPendingCards(grid); });
  }

  function getGridBatchRenderer(grid, opts) {
    if (grid.__ltvBatchRenderer) {
      grid.__ltvBatchRenderer.opts = opts;
      return grid.__ltvBatchRenderer;
    }

    var state = {
      opts: opts,
      items: [],
      rendered: 0,
      sentinel: null,
      observer: null,
      idleHandle: null
    };

    function ensureSentinel() {
      if (!state.sentinel) {
        state.sentinel = document.createElement('div');
        state.sentinel.className = 'last-24-tabs__grid-sentinel';
        state.sentinel.setAttribute('aria-hidden', 'true');
      }
      grid.appendChild(state.sentinel);
    }

    /* Spinner row while the next page is in flight. Placed after the sentinel, so cards
       appended before the sentinel always land above it. */
    function showMoreSpinner() {
      if (!state.moreSpinner) {
        state.moreSpinner = document.createElement('div');
        state.moreSpinner.className = 'last-24-tabs__more-loading';
        state.moreSpinner.setAttribute('aria-hidden', 'true');
        state.moreSpinner.innerHTML = '<span class="ltv-spinner"></span>';
      }
      grid.appendChild(state.moreSpinner);
    }

    function hideMoreSpinner() {
      if (state.moreSpinner && state.moreSpinner.parentNode) state.moreSpinner.remove();
    }

    function renderNextBatch() {
      if (state.rendered >= state.items.length) return;
      var o = state.opts;
      var end = Math.min(state.rendered + GRID_BATCH_SIZE, state.items.length);
      for (var i = state.rendered; i < end; i++) {
        var card = buildCard(
          state.items[i], i, o.sectionId, o.quantityErrorMax, o.moneyFormat, o.quantityLimit, o.soldOutSuffix,
          state.allowEager
        );
        /* One real card in, one stub out, in that order — the grid never changes height,
           so draining the batches costs no further layout shift. */
        var stub = grid.querySelector('.missed-auction-card--reserve');
        grid.insertBefore(card, stub || state.sentinel);
        if (stub) stub.remove();
        card.setAttribute('data-ltv-form-pending', '1');
        card.setAttribute('data-ltv-key', gridItemKey(state.items[i]));
      }
      state.rendered = end;
      ensureLazyInitBinding(grid);
      ltvRequestIdle(function () { sweepPendingCards(grid); });
      if (window.initMissedAuctionForms) window.initMissedAuctionForms();
      document.dispatchEvent(new CustomEvent('wishlist:refresh'));
      if (typeof o.onBatch === 'function') o.onBatch(state.rendered, state.items.length);
      if (state.rendered >= state.items.length) {
        /* Keep observing when a loader is wired: the sentinel is now the "fetch next page"
           trigger, not just a render trigger. */
        if (state.observer && state.sentinel && typeof state.opts.onNeedMore !== 'function') {
          state.observer.unobserve(state.sentinel);
        }
        if (state.idleHandle != null) { ltvCancelIdle(state.idleHandle); state.idleHandle = null; }
        rememberGridHeight(grid);
      }
    }

    /** Keep draining on idle so nothing depends on the sentinel becoming visible. */
    function scheduleDrain() {
      if (state.idleHandle != null) return;
      if (state.rendered >= state.items.length) return;
      state.idleHandle = ltvRequestIdle(function () {
        state.idleHandle = null;
        renderNextBatch();
        scheduleDrain();
      });
    }

    function clear() {
      if (state.idleHandle != null) { ltvCancelIdle(state.idleHandle); state.idleHandle = null; }
      /* Removes reservation stubs too — they carry .missed-auction-card. */
      var cards = grid.querySelectorAll('.missed-auction-card');
      for (var i = 0; i < cards.length; i++) cards[i].remove();
      state.items = [];
      state.rendered = 0;
    }

    function render(items) {
      clear();
      state.items = items || [];
      ensureSentinel();
      /* Final height in one step, before anything paints: stubs for every card that will
         render, then the first batch swaps its share of them for real cards. */
      /* Measured once per render, before any card exists: a grid that starts below the
         viewport can never hold the LCP element, so nothing in it should pre-empt the
         resource that does. */
      var gridTop = grid.getBoundingClientRect().top;
      state.allowEager = gridTop < (window.innerHeight || 800);
      setGridStubCount(grid, state.items.length, state.sentinel);
      rememberGridCardCount(grid, state.items.length);
      /* The stubs now describe the real height exactly, so the parse-time floor has done
         its job and must go — leaving it would keep over-reserving whenever the auction
         count drops. Same task as the stubs, so this never reaches a paint on its own. */
      grid.style.minHeight = '';
      /* First batch synchronously: the top of the grid must be in the DOM before
         paint, or the LCP image cannot be discovered early. */
      renderNextBatch();
      if (!state.observer && 'IntersectionObserver' in window) {
        state.observer = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            if (state.rendered < state.items.length) {
              renderNextBatch();
            } else if (typeof state.opts.onNeedMore === 'function') {
              /* Everything downloaded is on screen and the sentinel is in view — pull the
                 next page. Guarded so a burst of intersections cannot fire several
                 overlapping requests for the same cursor. */
              if (!state.loadingMore) {
                state.loadingMore = true;
                showMoreSpinner();
                state.opts.onNeedMore(function () {
                  state.loadingMore = false;
                  hideMoreSpinner();
                });
              }
            }
          }
        }, { root: null, rootMargin: '300px 0px' });
      }
      if (state.observer && state.sentinel) state.observer.observe(state.sentinel);
      scheduleDrain();
    }

    /** Add a fetched page and render it, without clearing what is already on screen. */
    function append(items) {
      if (!items || !items.length) return;
      state.items = state.items.concat(items);
      /* Stubs would otherwise be inserted ahead of the new cards; the page we just got is
         the reservation. */
      renderNextBatch();
      scheduleDrain();
    }

    /* True while the grid must not be swapped under the shopper: batches still draining,
       a next page in flight, or a swap already waiting on images. */
    function isBusy() {
      return state.rendered < state.items.length || !!state.loadingMore || !!state.reconciling;
    }

    /**
     * Show a fresh list without a blink. Cards for auctions already on screen are kept as
     * they are (loaded image, picked variant, qty); only new auctions get a card, built off
     * screen and shown once its image has decoded. Moved cards slide to their new place,
     * new ones fade in. Returns false when the grid is busy and nothing was done.
     */
    function reconcile(items) {
      if (isBusy()) return false;
      items = items || [];
      var nextKeys = items.map(gridItemKey);
      var onScreen = grid.querySelectorAll('.missed-auction-card[data-ltv-key]');
      var existing = {};
      var sameOrder = onScreen.length === nextKeys.length;
      for (var i = 0; i < onScreen.length; i++) {
        var k = onScreen[i].getAttribute('data-ltv-key');
        if (!existing[k]) existing[k] = onScreen[i];
        if (k !== nextKeys[i]) sameOrder = false;
      }
      if (sameOrder) {
        state.items = items;
        return true;
      }

      var o = state.opts;
      var used = {};
      var nodes = [];
      var added = [];
      for (var n = 0; n < items.length; n++) {
        var key = nextKeys[n];
        var node = !used[key] && existing[key];
        if (node) {
          used[key] = true;
        } else {
          node = buildCard(items[n], n, o.sectionId, o.quantityErrorMax, o.moneyFormat, o.quantityLimit, o.soldOutSuffix, false);
          node.setAttribute('data-ltv-form-pending', '1');
          node.setAttribute('data-ltv-key', key);
          added.push(node);
        }
        nodes.push(node);
      }

      state.reconciling = true;
      var gen = state.gen;
      preloadCardImages(added).then(function () {
        state.reconciling = false;
        /* render() or clear() ran while the images loaded — that view owns the grid now. */
        if (gen !== state.gen) return;
        swapCards(nodes, added, used, onScreen);
        state.items = items;
        state.rendered = items.length;
        ensureLazyInitBinding(grid);
        ltvRequestIdle(function () { sweepPendingCards(grid); });
        if (window.initMissedAuctionForms) window.initMissedAuctionForms();
        document.dispatchEvent(new CustomEvent('wishlist:refresh'));
        if (typeof o.onBatch === 'function') o.onBatch(state.rendered, state.items.length);
        rememberGridCardCount(grid, state.items.length);
        rememberGridHeight(grid);
      });
      return true;
    }

    function swapCards(nodes, added, used, onScreen) {
      var animate = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var scrollsSideways = grid.scrollWidth > grid.clientWidth + 1;
      /* Keep what the shopper is looking at still. If they have scrolled into the grid,
         pin the first visible kept card; if they are at its start, let new cards show. */
      var anchor = null;
      var anchorRect = null;
      var gridRect = grid.getBoundingClientRect();
      var scrolledIn = scrollsSideways ? grid.scrollLeft > 10 : gridRect.top < 0;
      var before = [];
      for (var i = 0; i < onScreen.length; i++) {
        var key = onScreen[i].getAttribute('data-ltv-key');
        if (!used[key] || onScreen[i].parentNode !== grid) continue;
        var r = onScreen[i].getBoundingClientRect();
        before.push({ el: onScreen[i], rect: r });
        if (scrolledIn && !anchor && (scrollsSideways ? r.right > gridRect.left : r.bottom > 0)) {
          anchor = onScreen[i];
          anchorRect = r;
        }
      }

      ensureSentinel();
      for (var j = 0; j < onScreen.length; j++) {
        if (!used[onScreen[j].getAttribute('data-ltv-key')]) onScreen[j].remove();
      }
      for (var n = 0; n < nodes.length; n++) grid.insertBefore(nodes[n], state.sentinel);

      if (anchor) {
        var nowRect = anchor.getBoundingClientRect();
        if (scrollsSideways) {
          /* The track has scroll-behavior:smooth; this correction must land in one step. */
          var prevBehavior = grid.style.scrollBehavior;
          grid.style.scrollBehavior = 'auto';
          grid.scrollLeft += nowRect.left - anchorRect.left;
          grid.style.scrollBehavior = prevBehavior;
        } else {
          window.scrollBy(0, nowRect.top - anchorRect.top);
        }
      }

      if (!animate) return;
      /* FLIP: put every kept card back where it was, then let it glide to its new place. */
      var moved = [];
      for (var b = 0; b < before.length; b++) {
        var after = before[b].el.getBoundingClientRect();
        var dx = before[b].rect.left - after.left;
        var dy = before[b].rect.top - after.top;
        if (Math.abs(dx) < 1 && Math.abs(dy) < 1) continue;
        before[b].el.style.transition = 'none';
        before[b].el.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
        moved.push(before[b].el);
      }
      for (var a = 0; a < added.length; a++) added[a].classList.add('missed-auction-card--entering');
      if (moved.length) {
        void grid.offsetWidth;
        for (var m = 0; m < moved.length; m++) {
          moved[m].style.transition = 'transform ' + GRID_SWAP_MS + 'ms ease';
          moved[m].style.transform = '';
        }
      }
      setTimeout(function () {
        for (var c = 0; c < moved.length; c++) moved[c].style.transition = '';
        for (var d = 0; d < added.length; d++) added[d].classList.remove('missed-auction-card--entering');
      }, GRID_SWAP_MS + 50);
    }

    state.gen = 0;
    state.render = function (items) { state.gen++; render(items); };
    state.append = append;
    state.clear = function () { state.gen++; clear(); };
    state.reconcile = reconcile;
    state.isBusy = isBusy;
    grid.__ltvBatchRenderer = state;
    return state;
  }

  /* ---------------------------------------------------------------------------
   * Background refresh of Last 24 Items / Last 24 Hours
   *
   * Both lists used to load once, so a shopper who kept the page open never saw a newly
   * ended auction. They now reload:
   *   - after an auction ends ('ltv:auction-ended' from the on-air updater). Waits a few
   *     seconds so the end consumer has cleared the server cache first, plus a random
   *     spread so every open tab does not hit the server in the same second;
   *   - when the tab becomes visible again;
   *   - every 60 s while the tab is visible, as a fallback (the Missed Auctions page has
   *     no PubNub, so this is its main trigger).
   * Each refresher swaps the list in place (reconcile()), so nothing blinks.
   * ------------------------------------------------------------------------- */
  var LIST_REFRESH_INTERVAL_MS = 60000;
  var LIST_REFRESH_AFTER_END_MS = 3000;
  var LIST_REFRESH_SPREAD_MS = 5000;
  var LIST_REFRESH_MIN_GAP_MS = 15000;
  var listRefreshers = [];
  var lastListRefreshAt = Date.now();
  var endRefreshTimer = null;

  function refreshLists() {
    lastListRefreshAt = Date.now();
    for (var i = 0; i < listRefreshers.length; i++) {
      try { listRefreshers[i](); } catch (e) { console.warn('[Live TV] list refresh failed:', e); }
    }
  }

  function registerListRefresher(fn) {
    listRefreshers.push(fn);
    if (listRefreshers.length > 1) return;
    document.addEventListener('ltv:auction-ended', function () {
      if (endRefreshTimer) return;
      endRefreshTimer = setTimeout(function () {
        endRefreshTimer = null;
        refreshLists();
      }, LIST_REFRESH_AFTER_END_MS + Math.round(Math.random() * LIST_REFRESH_SPREAD_MS));
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      if (Date.now() - lastListRefreshAt < LIST_REFRESH_MIN_GAP_MS) return;
      refreshLists();
    });
    setInterval(function () {
      if (document.visibilityState !== 'visible') return;
      if (Date.now() - lastListRefreshAt < LIST_REFRESH_INTERVAL_MS - 1000) return;
      refreshLists();
    }, LIST_REFRESH_INTERVAL_MS);
  }

  /** A refresh must not move a card while the shopper is using a dropdown or qty box in it. */
  function shopperIsUsingGrid(grid) {
    var el = document.activeElement;
    return !!(el && grid.contains(el) && /^(SELECT|INPUT|TEXTAREA)$/.test(el.tagName));
  }

  function run(grid) {
    var apiUrl = grid.getAttribute('data-tab-api-url') || '/apps/live-tv/last-24-items';
    var limit = parseInt(grid.getAttribute('data-cards-limit') || '24', 10) || 24;
    var moneyFormat = grid.getAttribute('data-money-format') || '£{{amount}}';
    var soldOutSuffix = grid.getAttribute('data-variant-sold-out-suffix') || ' (sold out)';
    var sectionId = grid.getAttribute('data-section-id') || '';
    var quantityErrorMax = grid.getAttribute('data-quantity-error-max') || 'This item has a maximum of {{ maximum }}';
    var quantityLimit = grid.getAttribute('data-quantity-limit');
    var loadingEl = grid.querySelector('[data-tab-loading]');
    var panelInner = grid.closest && grid.closest('.last-24-tabs__panel-inner');
    var emptyEl = panelInner ? panelInner.querySelector('[data-tab-empty]') : null;

    function renderer() {
      return getGridBatchRenderer(grid, {
        sectionId: sectionId,
        quantityErrorMax: quantityErrorMax,
        moneyFormat: moneyFormat,
        quantityLimit: quantityLimit,
        soldOutSuffix: soldOutSuffix,
        /* Re-measured after every batch: the arrows compare scrollWidth against
           clientWidth, and both change as cards arrive. */
        onBatch: function () {
          document.dispatchEvent(new CustomEvent('filter:update'));
          initLast24Slider();
        }
      });
    }

    function setDataAvailable(available) {
      const roaWrapper = document.querySelector('.show_only_roa');
      if (roaWrapper) roaWrapper.classList.toggle('data_not_available', !available);
    }

    /* `fresh` skips the browser HTTP cache, so a refresh works even while an older app
       deploy still sends max-age. */
    function fetchSlice(fresh) {
      return fetch(apiUrl, {
        credentials: 'same-origin',
        cache: fresh ? 'no-store' : 'default',
        headers: { 'ngrok-skip-browser-warning': 'true' }
      })
      .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error(res.status + ' ' + res.statusText)); })
      .then(function (json) {
        var list = (json && json.data && json.data.auctions) ? json.data.auctions : (json && json.auctions) ? json.auctions : [];
        return list.filter(auctionHasShopifyProduct).slice(0, limit);
      });
    }

    var refreshing = false;
    function refresh() {
      if (refreshing || shopperIsUsingGrid(grid)) return;
      var current = grid.__ltvBatchRenderer;
      if (current && current.isBusy()) return;
      refreshing = true;
      fetchSlice(true)
        .then(function (slice) {
          refreshing = false;
          /* An empty answer is more likely a blip than a day with no auctions — keep what is shown. */
          if (!slice.length || shopperIsUsingGrid(grid)) return;
          if (emptyEl) emptyEl.setAttribute('hidden', '');
          setDataAvailable(true);
          var r = renderer();
          if (!grid.querySelector('.missed-auction-card[data-ltv-key]')) r.render(slice);
          else r.reconcile(slice);
        })
        .catch(function (err) {
          refreshing = false;
          console.warn('[Live TV] Tab items refresh failed:', apiUrl, err);
        });
    }

    reserveFirstBatch(grid);

    fetchSlice(false)
    .then(function (slice) {
      if (loadingEl) loadingEl.remove();
      grid.removeAttribute('aria-busy');

      if (slice.length === 0) {
        setGridStubCount(grid, 0, null);
        rememberGridCardCount(grid, 0);
        if (emptyEl) emptyEl.removeAttribute('hidden');
        setDataAvailable(false);
        return;
      }
      renderer().render(slice);
      setDataAvailable(true);
    })
    .catch(function (err) {
      if (loadingEl) loadingEl.remove();
      grid.removeAttribute('aria-busy');
      setGridStubCount(grid, 0, null);
      if (emptyEl) emptyEl.removeAttribute('hidden');
      setDataAvailable(false);
      console.warn('[Live TV] Tab items fetch failed:', apiUrl, err);
    })
    .then(function () {
      /* Best Buys is not a "what just aired" list; it keeps its load-once behaviour. */
      if (apiUrl.indexOf('last-24-items') !== -1) registerListRefresher(refresh);
    });
  }

  // Last 24 Hours: fetch data.hours[], render inner tabs (title + hour), show auctions for selected hour.
  function runLast24Hours(panel) {
    var grid = panel.querySelector('[data-tab-items-grid][data-tab-type="last-24-hours"]');
    if (!grid) return;
    var presenterAvatarFallbackUrl =
      (panel.getAttribute('data-presenter-avatar-fallback') || '').trim() ||
      'https://tjcuk.sirv.com/IW/global/face.svg';
    var stripOuter = panel.querySelector('[data-strip-outer]');
    if (stripOuter) stripOuter.setAttribute('hidden', '');
    var apiUrl = grid.getAttribute('data-tab-api-url') || '/apps/live-tv/last-24-hours';
    var limit = parseInt(grid.getAttribute('data-cards-limit') || '24', 10) || 24;
    var moneyFormat = grid.getAttribute('data-money-format') || '£{{amount}}';
    var soldOutSuffix = grid.getAttribute('data-variant-sold-out-suffix') || ' (sold out)';
    var sectionId = grid.getAttribute('data-section-id') || '';
    var quantityErrorMax = grid.getAttribute('data-quantity-error-max') || 'This item has a maximum of {{ maximum }}';
    var quantityLimit = grid.getAttribute('data-quantity-limit');
    var loadingEl = grid.querySelector('[data-tab-loading]');
    var stripWrap = panel.querySelector('.last-24-tabs__strip-wrap');
    var contentWrap = panel.querySelector('[data-last-24-hours-content]');
    var aboveGrid = contentWrap ? contentWrap.querySelector('[data-above-grid]') : null;
    var emptyEl = contentWrap ? contentWrap.querySelector('[data-tab-empty]') : null;
    var filtersId = grid.getAttribute('data-missed-filters-id');
    /* Must be the [data-missed-auctions-filters] node, not a parent with duplicate id (strip lives outside filters). */
    var filtersEl = panel.querySelector('[data-missed-auctions-filters]');
    if (!filtersEl && filtersId) {
      filtersEl = document.getElementById(filtersId);
    }
    var currentHours = [];
    /** Hour metadata from the API; auctions are fetched per page (closure). */
    var fullHours = null;

    /* ---------------------------------------------------------------------
     * Paging
     *
     * The endpoint used to hand over every auction at once — ~424 KB for 179 of them,
     * and every card got built whether or not anyone scrolled to it. Now the first
     * page arrives with the hour metadata and the grid sentinel pulls the rest.
     *
     * Hour metadata always comes in full (it is ~5 KB for a day) because the hour
     * strip and the filter bar key off showDate/presenterName and must be complete
     * before the shopper can filter anything.
     * ------------------------------------------------------------------- */
    var PAGE_SIZE = 20;
    /** Params identifying the current view, so the next page continues the same list. */
    var pageQuery = {};
    var pageCursor = null;
    /* Bumped by every view switch — hour tab, "All", or a filter change. A response may
       only touch the grid while it still matches, so a slow earlier request cannot
       repaint over the results a later one already drew. */
    var viewRequestId = 0;

    function buildPageUrl(extra) {
      var qs = ['limit=' + ((extra && extra.limit) || PAGE_SIZE)];
      for (var k in pageQuery) {
        if (Object.prototype.hasOwnProperty.call(pageQuery, k) && pageQuery[k]) {
          qs.push(k + '=' + encodeURIComponent(pageQuery[k]));
        }
      }
      if (extra && extra.after) qs.push('after=' + encodeURIComponent(extra.after));
      return apiUrl + (apiUrl.indexOf('?') === -1 ? '?' : '&') + qs.join('&');
    }

    function fetchPage(extra) {
      return fetch(buildPageUrl(extra), {
        credentials: 'same-origin',
        /* A background refresh skips the browser HTTP cache (see fetchSlice in run()). */
        cache: extra && extra.fresh ? 'no-store' : 'default',
        headers: { 'Accept': 'application/json', 'ngrok-skip-browser-warning': 'true' }
      })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error(res.status + ' ' + res.statusText)); })
        .then(function (json) { return (json && json.data) ? json.data : { hours: [], auctions: [], total: 0, nextCursor: null }; })
        .then(stampAirSlots);
    }

    /* Each auction carries its scheduleHourId; the hour row holds the presenter and time.
       Copy them onto the auction so its card shows "Caroline Lyndsay at 9 AM" (airSlotHtml). */
    function stampAirSlots(data) {
      var byId = {};
      (data.hours || fullHours || []).forEach(function (h) {
        if (h && h.scheduleHourId != null) byId[String(h.scheduleHourId)] = h;
      });
      (data.auctions || []).forEach(function (a) {
        var h = a && byId[String(a.scheduleHourId)];
        if (!h) return;
        if (!a.presenterName) a.presenterName = h.presenterName || '';
        if (!a.airHour) a.airHour = h.hour || '';
        if (!a.airShowDate) a.airShowDate = h.showDate || '';
      });
      return data;
    }

    /** Called by the grid sentinel once everything downloaded is on screen. */
    function loadNextPage(done) {
      if (!pageCursor) { done(); return; }
      var cursor = pageCursor;
      /* The view can change while this page is in flight; its rows belong to the old
         filter and must not be appended to the new grid. */
      var reqId = viewRequestId;
      fetchPage({ after: cursor })
        .then(function (data) {
          if (reqId !== viewRequestId || cursor !== pageCursor) { done(); return; }
          pageCursor = data.nextCursor || null;
          gridRenderer().append(data.auctions || []);
          done();
        })
        .catch(function (err) {
          console.warn('[Live TV] next page failed:', err);
          done();
        });
    }

    /** Render the first page of a view and arm the sentinel for the rest. */
    function showFirstPage(query, data) {
      pageQuery = query || {};
      pageCursor = data.nextCursor || null;
      var auctions = (data.auctions || []).filter(auctionHasShopifyProduct);
      if (emptyEl) {
        if (!auctions.length) emptyEl.removeAttribute('hidden');
        else emptyEl.setAttribute('hidden', '');
      }
      if (filtersEl && window.MissedAuctionsFilters) {
        /* The real figure from the server, not the page length. */
        window.MissedAuctionsFilters.setProductCount(filtersEl, data.total || auctions.length);
      }
      startBatchedRender(auctions);
    }

    function formatHourLabel(hourValue, showDate, fallbackIndex) {
      return formatAirHourLabel(hourValue, showDate) || ('Hour ' + (fallbackIndex + 1));
    }

    /** Minutes past midnight for the start of a slot label ("12 AM to 1 AM", "1.00 PM", "13.00"). */
    function parseHourStartMinutes(hourValue) {
      var raw = hourValue != null ? String(hourValue).trim() : '';
      if (raw === '' || raw === '00.00' || raw === '00:00') return null;
      var start = (raw.split(/\s*(?:to|-|–|—)\s*/i)[0] || raw).trim();
      var parts = start.match(/^(\d{1,2})(?:[.:](\d{2}))?\s*(?:([ap])\.?m\.?)?$/i);
      if (!parts) return null;
      var hours24 = parseInt(parts[1], 10);
      var minutes = parts[2] ? parseInt(parts[2], 10) : 0;
      var meridiem = parts[3] ? parts[3].toLowerCase() : '';
      if (meridiem === 'a') hours24 = hours24 === 12 ? 0 : hours24;
      else if (meridiem === 'p') hours24 = hours24 === 12 ? 12 : hours24 + 12;
      if (hours24 > 23 || minutes > 59) return null;
      return hours24 * 60 + minutes;
    }

    /* showDate repeats across every hour of the same day, so it only supplies the calendar
       date; the position within the day comes from `hour`. Combining both keeps midnight
       rollover correct — Sunday 11 PM sorts below Monday 12 AM. */
    function hourSortKey(h) {
      var showDateTs = Date.parse(String((h && h.showDate) || ''));
      if (isNaN(showDateTs)) return -Infinity;
      var minutes = parseHourStartMinutes(h && h.hour);
      if (minutes === null) return showDateTs;
      var day = new Date(showDateTs);
      day.setHours(0, 0, 0, 0);
      return day.getTime() + minutes * 60000;
    }

    /**
     * Newest hour first. Two slots sharing an air time — a duplicated day+hour label, or a
     * placeholder time landing on that day's midnight — keep the order they arrived in.
     * That makes the sort idempotent, so re-ordering a response the server already ordered
     * is a no-op; reversing ties here would instead undo the server's tie-break and show
     * the older of the pair first.
     */
    function sortHoursNewestFirst(hours) {
      if (!hours || hours.length < 2) return hours || [];
      return hours
        .map(function (h, feedIndex) { return { h: h, feedIndex: feedIndex, key: hourSortKey(h) }; })
        .sort(function (a, b) { return a.key === b.key ? a.feedIndex - b.feedIndex : b.key - a.key; })
        .map(function (entry) { return entry.h; });
    }

    function formatDayAndHourLabel(showDate, hourValue, fallbackIndex) {
      var dayLabel = '';
      var raw = showDate != null ? String(showDate).trim() : '';
      if (raw) {
        var d = new Date(raw);
        if (!isNaN(d.getTime())) {
          dayLabel = d.toLocaleDateString('en-GB', { weekday: 'long' });
        }
      }
      var hourLabel = formatHourLabel(hourValue, showDate, fallbackIndex);
      if (dayLabel && hourLabel) return dayLabel + ', ' + hourLabel;
      return dayLabel || hourLabel;
    }

    function revealAboveGrid() {
      if (loadingEl) loadingEl.remove();
      grid.removeAttribute('aria-busy');
      if (aboveGrid) {
        aboveGrid.removeAttribute('hidden');
        aboveGrid.removeAttribute('aria-hidden');
      }
    }

    function hideAboveGrid() {
      if (!aboveGrid) return;
      aboveGrid.setAttribute('hidden', '');
      aboveGrid.setAttribute('aria-hidden', 'true');
    }

    function hourPassesFilters(h, hourIndex) {
      if (!filtersEl || !window.MissedAuctionsFilters || !h) return true;
      var sel = window.MissedAuctionsFilters.getSelected(filtersEl);
      var showTimeOpt = window.MissedAuctionsFilters.getShowTimeOption ? window.MissedAuctionsFilters.getShowTimeOption(h, hourIndex) : null;
      var showTimeKey = showTimeOpt && showTimeOpt.id ? showTimeOpt.id : String(h.showDate || '').trim();
      var okDay = sel.showDates.length === 0 || sel.showDates.indexOf(showTimeKey) !== -1;
      var presenterNameStr = String(h.presenterName || '').trim();
      var okPresenter = sel.presenterNames.length === 0 || sel.presenterNames.indexOf(presenterNameStr) !== -1;
      return okDay && okPresenter;
    }

    function getFilteredHours(hours) {
      if (!hours) return [];
      if (!filtersEl || !window.MissedAuctionsFilters) return hours;
      return hours.filter(function (hour, i) {
        return hourPassesFilters(hour, i);
      });
    }

    /** Refresh grid only; hour strip stays full API list (matches IW: refinements do not shrink the carousel). */
    function refreshGridForFilters() {
      var h = fullHours;
      if (!h || !h.length) return;
      var filtered = getFilteredHours(h);
      if (allTab && allTab.getAttribute('aria-selected') === 'true') {
        populateAll(filtered);
        return;
      }
      var selectedBtn = stripWrap && stripWrap.querySelector('.last-24-tabs__inner-tab[aria-selected="true"]');
      if (selectedBtn) {
        /* Prefer the stable AMS id stamped at render time over the positional index,
           which can drift after a re-sort. */
        var stableId = selectedBtn.getAttribute('data-schedule-hour-id');
        if (stableId) {
          populateHourById(stableId);
          return;
        }
        var idx = parseInt(selectedBtn.getAttribute('data-hour-index'), 10);
        if (!isNaN(idx)) {
          populateHour(h, idx);
          return;
        }
      }
      populateAll(filtered);
    }

    /* Same batched renderer the other grids use — see getGridBatchRenderer(). */
    function gridRenderer() {
      return getGridBatchRenderer(grid, {
        sectionId: sectionId,
        quantityErrorMax: quantityErrorMax,
        moneyFormat: moneyFormat,
        quantityLimit: quantityLimit,
        soldOutSuffix: soldOutSuffix,
        onNeedMore: loadNextPage
      });
    }

    function clearGrid() {
      gridRenderer().clear();
    }

    function startBatchedRender(items) {
      gridRenderer().render(items);
    }

    function populateHour(hoursList, hourIndex) {
      var reqId = ++viewRequestId;
      var hour = hoursList[hourIndex];
      if (!hourPassesFilters(hour, hourIndex)) {
        clearGrid();
        if (emptyEl) emptyEl.removeAttribute('hidden');
        if (filtersEl && window.MissedAuctionsFilters) {
          window.MissedAuctionsFilters.setProductCount(filtersEl, 0);
        }
        return;
      }
      var query = { hour: String((hour && hour.scheduleHourId) || '') };
      /* pageQuery must be set before fetchPage so buildPageUrl reads the correct
         filter — buildPageUrl reads pageQuery for view params and extra only for
         the cursor. Previously fetchPage(query) passed query as extra, which
         buildPageUrl ignored (only extra.after is read), so no ?hour= was sent. */
      pageQuery = query;
      fetchPage({})
        .then(function (data) {
          if (reqId !== viewRequestId) return;
          showFirstPage(query, data);
        })
        .catch(function (err) {
          if (reqId !== viewRequestId) return;
          console.warn('[Live TV] hour page failed:', err);
          clearGrid();
          if (emptyEl) emptyEl.removeAttribute('hidden');
        });
    }

    /**
     * Fetch and display a single hour's auctions using its stable AMS scheduleHourId,
     * bypassing any array-index lookup. This is the entry point used by tab click handlers
     * so that a cache refresh or re-sort between page load and click cannot swap the id.
     */
    function populateHourById(scheduleHourId) {
      if (!scheduleHourId) return;
      var reqId = ++viewRequestId;
      /* Still run the filter check: find the matching hour in fullHours so hourPassesFilters
         can inspect presenterName / showDate. Fall back gracefully if not found. */
      var matchHour = null;
      var matchIndex = 0;
      if (fullHours) {
        for (var fi = 0; fi < fullHours.length; fi++) {
          if (String(fullHours[fi].scheduleHourId) === String(scheduleHourId)) {
            matchHour = fullHours[fi];
            matchIndex = fi;
            break;
          }
        }
      }
      if (matchHour && !hourPassesFilters(matchHour, matchIndex)) {
        clearGrid();
        if (emptyEl) emptyEl.removeAttribute('hidden');
        if (filtersEl && window.MissedAuctionsFilters) {
          window.MissedAuctionsFilters.setProductCount(filtersEl, 0);
        }
        return;
      }
      var query = { hour: String(scheduleHourId) };
      pageQuery = query;
      fetchPage({})
        .then(function (data) {
          if (reqId !== viewRequestId) return;
          showFirstPage(query, data);
        })
        .catch(function (err) {
          if (reqId !== viewRequestId) return;
          console.warn('[Live TV] hour page failed:', err);
          clearGrid();
          if (emptyEl) emptyEl.removeAttribute('hidden');
        });
    }

    function populateAll(hoursToUse) {
      var reqId = ++viewRequestId;
      /* Only the hours that survive the filter bar; empty means "no restriction", which
         keeps the URL short on the common unfiltered view. */
      var ids = [];
      var unfiltered = !hoursToUse || !fullHours || hoursToUse.length === fullHours.length;
      if (!unfiltered) {
        for (var i = 0; i < hoursToUse.length; i++) {
          var id = hoursToUse[i] && hoursToUse[i].scheduleHourId;
          if (id != null && id !== '') ids.push(String(id));
        }
        if (!ids.length) {
          clearGrid();
          if (emptyEl) emptyEl.removeAttribute('hidden');
          if (filtersEl && window.MissedAuctionsFilters) {
            window.MissedAuctionsFilters.setProductCount(filtersEl, 0);
          }
          return;
        }
      }
      var query = unfiltered ? {} : { hours: ids.join(',') };
      pageQuery = query;
      fetchPage({})
        .then(function (data) {
          if (reqId !== viewRequestId) return;
          showFirstPage(query, data);
        })
        .catch(function (err) {
          if (reqId !== viewRequestId) return;
          console.warn('[Live TV] page failed:', err);
          clearGrid();
          if (emptyEl) emptyEl.removeAttribute('hidden');
        });
    }

    function renderHourTabs(hoursToRender) {
      if (!stripWrap) return;
      currentHours = Array.isArray(hoursToRender) ? hoursToRender.slice() : [];
      /* A refresh re-runs this; tabs already on screen are kept (no avatar re-load flash). */
      var reusable = {};
      var stripTabs = stripWrap.querySelectorAll('.last-24-tabs__inner-tab, .last-24-tabs__strip-divider');
      for (var s = 0; s < stripTabs.length; s++) {
        var oldId = stripTabs[s].getAttribute('data-schedule-hour-id');
        if (oldId) reusable[oldId] = stripTabs[s];
        stripTabs[s].remove();
      }
      for (var i = 0; i < currentHours.length; i++) {
        if (i > 0) {
          var div = document.createElement('span');
          div.className = 'last-24-tabs__strip-divider';
          div.setAttribute('aria-hidden', 'true');
          stripWrap.appendChild(div);
        }
        var h = currentHours[i];
        var hourIdKey = String(h.scheduleHourId != null ? h.scheduleHourId : '');
        if (hourIdKey && reusable[hourIdKey]) {
          reusable[hourIdKey].setAttribute('data-hour-index', i);
          stripWrap.appendChild(reusable[hourIdKey]);
          delete reusable[hourIdKey];
          continue;
        }
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'last-24-tabs__tab last-24-tabs__inner-tab';
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', 'false');
        btn.setAttribute('data-hour-index', i);
        /* Stamp the stable AMS id so the click handler never has to look up
           currentHours[idx] — that mapping breaks whenever the array is re-sorted. */
        btn.setAttribute('data-schedule-hour-id', String(h.scheduleHourId != null ? h.scheduleHourId : ''));
        var avatarPlaceholder = document.createElement('span');
        avatarPlaceholder.className = 'last-24-tabs__inner-tab-avatar-placeholder';
        avatarPlaceholder.setAttribute('aria-hidden', 'true');
        var presenterName = (h.presenterName && String(h.presenterName).trim()) ? String(h.presenterName).trim() : '';
        var avatarUrl = avatarBaseUrl && presenterName ? (avatarBaseUrl + encodeURIComponent(presenterName) + '.jpg') : '';
        if (avatarUrl) {
          var avatarImg = document.createElement('img');
          avatarImg.className = 'last-24-tabs__inner-tab-avatar';
          avatarImg.alt = '';
          avatarImg.onerror = function () {
            this.onerror = null;
            this.src = presenterAvatarFallbackUrl;
          };
          avatarImg.src = avatarUrl;
          avatarPlaceholder.appendChild(avatarImg);
        } else {
          var avatarPlaceHolder = document.createElement('img');
          avatarPlaceHolder.className = 'last-24-tabs__inner-tab-avatar';
          avatarPlaceHolder.src = presenterAvatarFallbackUrl;
          avatarPlaceHolder.alt = '';
          avatarPlaceholder.appendChild(avatarPlaceHolder);
        }
        btn.appendChild(avatarPlaceholder);
        var hourSpan = document.createElement('span');
        hourSpan.className = 'last-24-tabs__inner-tab-hour';
        hourSpan.textContent = formatDayAndHourLabel(h.showDate, h.hour, i);
        btn.appendChild(hourSpan);
        var titleSpan = document.createElement('span');
        titleSpan.className = 'last-24-tabs__inner-tab-title';
        var titleText = (h.title && String(h.title).trim()) ? String(h.title).trim() : '';
        var presenterForLabel = presenterName ? presenterName.replace(/\./g, ' ') : '';
        var tabTitleLabel = '';
        if (titleText && presenterForLabel) tabTitleLabel = titleText + ' with ' + presenterForLabel;
        else tabTitleLabel = titleText || presenterForLabel;
        titleSpan.textContent = tabTitleLabel.trim() || '\u00A0';
        btn.appendChild(titleSpan);
        (function (hourId, tabBtn) {
          tabBtn.addEventListener('click', function () {
            if (allTab) allTab.setAttribute('aria-selected', 'false');
            /* Position looked up on click: a refresh can put a new hour in front of this tab. */
            var tabs = stripWrap.querySelectorAll('.last-24-tabs__inner-tab');
            setActiveInnerTab(tabs, Array.prototype.indexOf.call(tabs, tabBtn));
            if (allTab) hideAboveGrid();
            /* Use the id baked into this button at render time, not currentHours[idx],
               which can point at a different slot after a cache refresh or re-sort. */
            populateHourById(hourId);
          });
        })(hourIdKey, btn);
        stripWrap.appendChild(btn);
      }
    }

    function setActiveInnerTab(buttons, index) {
      for (var j = 0; j < buttons.length; j++) {
        var sel = j === index;
        buttons[j].setAttribute('aria-selected', sel);
        buttons[j].classList.toggle('last-24-tabs__tab--selected', sel);
      }
    }

    /* ---- Background refresh (see registerListRefresher) ---- */
    /** The server's page-size cap; a refresh re-reads at most this many rows. */
    var MAX_REFRESH_PAGE = 96;
    var viewRefreshing = false;

    function hasActiveFilters() {
      if (!filtersEl || !window.MissedAuctionsFilters) return false;
      var sel = window.MissedAuctionsFilters.getSelected(filtersEl);
      return !!(sel && ((sel.showDates && sel.showDates.length) || (sel.presenterNames && sel.presenterNames.length)));
    }

    function sameHourIds(a, b) {
      if (!a || !b || a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) {
        if (String(a[i].scheduleHourId) !== String(b[i].scheduleHourId)) return false;
      }
      return true;
    }

    /** A new show hour started: add its tab and filter options, keeping the shopper's place. */
    function updateHourMeta(rawHours) {
      var next = sortHoursNewestFirst(rawHours || []);
      if (!next.length || sameHourIds(next, fullHours)) return;
      /* Show-time filter ids carry the row index, so a new hour would shift them under an
         active selection. Leave the hours alone until the shopper clears the filters. */
      if (hasActiveFilters()) return;
      fullHours = next;
      if (filtersEl && window.MissedAuctionsFilters) window.MissedAuctionsFilters.setHours(filtersEl, next);
      var stripScroll = stripWrap ? stripWrap.scrollLeft : 0;
      renderHourTabs(next);
      if (stripWrap) {
        stripWrap.scrollLeft = stripScroll;
        stripWrap.dispatchEvent(new Event('scroll'));
      }
    }

    function refreshView() {
      if (viewRefreshing || !fullHours || shopperIsUsingGrid(grid)) return;
      var r = gridRenderer();
      if (r.isBusy()) return;
      var reqId = viewRequestId;
      var query = pageQuery;
      var old = r.items || [];
      viewRefreshing = true;
      /* Re-read as many rows as are loaded now, so the grid does not shrink back to page 1. */
      fetchPage({ limit: Math.min(MAX_REFRESH_PAGE, Math.max(PAGE_SIZE, old.length)), fresh: true })
        .then(function (data) {
          viewRefreshing = false;
          /* The shopper switched hour or filter meanwhile — that view's own request wins. */
          if (reqId !== viewRequestId || query !== pageQuery || r.isBusy() || shopperIsUsingGrid(grid)) return;
          updateHourMeta(data.hours);
          var head = (data.auctions || []).filter(auctionHasShopifyProduct);
          /* An empty answer is more likely a blip than a view with no auctions — keep what is shown. */
          if (!head.length) return;
          /* More rows were loaded than one request may return: keep the loaded rows that come
             after the refreshed head, and the cursor that continues after them. */
          var cursor = data.nextCursor || null;
          var tail = [];
          var oldKeys = old.map(gridItemKey);
          var at = data.nextCursor ? oldKeys.indexOf(gridItemKey(head[head.length - 1])) : -1;
          if (at !== -1) {
            var inHead = {};
            for (var i = 0; i < head.length; i++) inHead[gridItemKey(head[i])] = true;
            tail = old.slice(at + 1).filter(function (item) { return !inHead[gridItemKey(item)]; });
            if (tail.length) cursor = pageCursor;
          }
          var merged = head.concat(tail);
          pageCursor = cursor;
          if (emptyEl) emptyEl.setAttribute('hidden', '');
          if (filtersEl && window.MissedAuctionsFilters) {
            window.MissedAuctionsFilters.setProductCount(filtersEl, data.total || merged.length);
          }
          if (!grid.querySelector('.missed-auction-card[data-ltv-key]')) r.render(merged);
          else r.reconcile(merged);
        })
        .catch(function (err) {
          viewRefreshing = false;
          console.warn('[Live TV] Last 24 Hours refresh failed:', err);
        });
    }

    var allTab = panel.querySelector('[data-last-24-hours-all-tab]');
    var avatarSampleUrl = (panel && panel.getAttribute('data-presenter-avatar-sample')) || '';
    var avatarBaseUrl = avatarSampleUrl ? avatarSampleUrl.substring(0, avatarSampleUrl.lastIndexOf('/') + 1) : '';

    reserveFirstBatch(grid);

    fetchPage({})
      .then(function (data) {
        /* API delivers hours in display order (newest hour first, newest auction first within each hour).
           Guard: middleware deployed before the air-time sort, and CDN-stale responses, can list
           hours in feed order — re-sort here. Sorting is idempotent, so an already-ordered
           response passes through unchanged. */
        var hours = sortHoursNewestFirst((data && data.hours) ? data.hours : []);
        fullHours = hours;
        if (!hours.length) {
          revealAboveGrid();
          if (emptyEl) emptyEl.removeAttribute('hidden');
          return;
        }
        revealAboveGrid();
        if (filtersEl && window.MissedAuctionsFilters) {
          window.MissedAuctionsFilters.setHours(filtersEl, hours);
          /* Done and Reset, popup and desktop alike, all end in a missed-filters-change
             dispatch, so this one listener covers every way a selection is applied. */
          filtersEl.addEventListener('missed-filters-change', refreshGridForFilters);
        }
        if (allTab) {
          allTab.setAttribute('aria-selected', 'true');
          allTab.addEventListener('click', function selectAll() {
            allTab.setAttribute('aria-selected', 'true');
            revealAboveGrid();
            if (stripWrap) {
              var btns = stripWrap.querySelectorAll('.last-24-tabs__inner-tab');
              for (var b = 0; b < btns.length; b++) {
                btns[b].setAttribute('aria-selected', 'false');
                btns[b].classList.remove('last-24-tabs__tab--selected');
              }
            }
            /* fullHours, not the first response: a refresh can add a new hour since. */
            populateAll(filtersEl && window.MissedAuctionsFilters ? getFilteredHours(fullHours) : fullHours);
          });
        }
        renderHourTabs(hours);
        if (allTab) {
          /* This response already carries page 1 — rendering it directly avoids an
             immediate second request for data we are holding. */
          showFirstPage({}, data);
        } else if (currentHours.length && stripWrap) {
          setActiveInnerTab(stripWrap.querySelectorAll('.last-24-tabs__inner-tab'), 0);
          populateHour(currentHours, 0);
        }
        if (stripOuter) stripOuter.removeAttribute('hidden');
        var stripEl = panel.querySelector('.last-24-tabs__strip-wrap');
        if (stripEl) {
          stripEl.scrollLeft = 0;
          setTimeout(function () { stripEl.dispatchEvent(new Event('scroll')); }, 0);
        }
        registerListRefresher(refreshView);
      })
      .catch(function (err) {
        revealAboveGrid();
        setGridStubCount(grid, 0, null);
        if (emptyEl) emptyEl.removeAttribute('hidden');
        console.warn('[Live TV] Last 24 Hours fetch failed:', apiUrl, err);
      });
  }

  var STRIP_SCROLL_STEP = 240;

  function updateStripArrowStates(strip, prevBtn, nextBtn) {
    if (!strip || !prevBtn || !nextBtn) return;
    var cw = strip.clientWidth;
    if (cw <= 0) {
      prevBtn.disabled = false;
      nextBtn.disabled = false;
      return;
    }
    var left = strip.scrollLeft;
    var maxLeft = strip.scrollWidth - cw;
    prevBtn.disabled = left <= 0;
    nextBtn.disabled = maxLeft <= 0 || left >= maxLeft - 1;
  }

  function initStripArrows() {
    /* Scroll + ResizeObserver per strip: keep prev/next disabled state in sync */
    var strips = document.querySelectorAll('[data-strip-outer]');
    strips.forEach(function (outer) {
      var strip = outer.querySelector('.last-24-tabs__strip-wrap');
      if (!strip) return;
      function updateArrows() {
        var prevBtn = outer.querySelector('[data-strip-prev]');
        var nextBtn = outer.querySelector('[data-strip-next]');
        updateStripArrowStates(strip, prevBtn, nextBtn);
      }
      strip.addEventListener('scroll', updateArrows);
      if (typeof ResizeObserver !== 'undefined') {
        (new ResizeObserver(updateArrows)).observe(strip);
      }
      updateArrows();
    });

    /* Single delegated click: works after div consolidation and when strip is revealed after init */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-strip-prev], [data-strip-next]');
      if (!btn) return;
      var panel = btn.closest && btn.closest('.last-24-tabs__panel');
      if (!panel) return;
      var strip = panel.querySelector && panel.querySelector('.last-24-tabs__strip-wrap');
      if (!strip) return;
      var prevBtn = panel.querySelector('[data-strip-prev]');
      var nextBtn = panel.querySelector('[data-strip-next]');
      if (btn.hasAttribute('data-strip-prev')) {
        strip.scrollBy({ left: -STRIP_SCROLL_STEP, behavior: 'smooth' });
      } else {
        strip.scrollBy({ left: STRIP_SCROLL_STEP, behavior: 'smooth' });
      }
      setTimeout(function () {
        updateStripArrowStates(strip, prevBtn, nextBtn);
      }, 350);
    });
  }

  /**
   * Safe to call repeatedly — cards now arrive in batches and the arrows must be
   * re-measured after each one, but the listeners must only ever be bound once or
   * a single arrow click would scroll once per batch that had been rendered.
   */
  function initLast24Slider() {
    var sliders = document.querySelectorAll('.last-24-tabs__slider');
    sliders.forEach(function(slider) {
      var track = slider.querySelector('.last-24-tabs__grid');
      var prevBtn = slider.querySelector('.last-24-tabs__arrow--prev');
      var nextBtn = slider.querySelector('.last-24-tabs__arrow--next');
      if (!track || !prevBtn || !nextBtn) return;
      if (slider.__ltvSliderBound) {
        slider.__ltvSliderBound();
        return;
      }
      function updateArrows() {
        var maxScrollLeft = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 10;
        nextBtn.disabled = track.scrollLeft >= maxScrollLeft - 10;
      }
      function getScrollAmount() {
        return track.clientWidth;
      }
      prevBtn.addEventListener('click', function() {
        track.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });
      nextBtn.addEventListener('click', function() {
        track.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });
      track.addEventListener('scroll', updateArrows);
      slider.__ltvSliderBound = updateArrows;
      updateArrows();
    });
  }

  function init() {
    initStripArrows();
    var grids = document.querySelectorAll('[data-tab-items-grid]');
    grids.forEach(function (grid) {
      var panel = grid.closest && grid.closest('.last-24-tabs__panel');
      var isStandaloneHours = panel && panel.hasAttribute('data-last-24-hours-standalone') && grid.getAttribute('data-tab-type') === 'last-24-hours';
      if (isStandaloneHours) {
        runLast24Hours(panel);
        return;
      }
      if (grid.hasAttribute('data-load-on-tab-select')) {
        if (!panel || !panel.id) return;
        var tabsRoot = grid.closest && grid.closest('.last-24-tabs');
        var tab = tabsRoot && tabsRoot.querySelector('[aria-controls="' + panel.id + '"]');
        if (tab) {
          tab.addEventListener('click', function onTabClick() {
            if (grid.hasAttribute('data-tab-items-loaded')) return;
            grid.setAttribute('data-tab-items-loaded', 'true');
            if (grid.getAttribute('data-tab-type') === 'last-24-hours') {
              runLast24Hours(panel);
            } else {
              run(grid);
            }
          }, { once: true });
        }
      } else {
        run(grid);
      }
    });
  }

  window.initMissedAuctionCardForm = initCardForm;
  window.liveTvMissedPlaceholderHtml = liveTvMissedPlaceholderHtml;
  window.liveTvCoaPlaceholderHtml = liveTvCoaPlaceholderHtml;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
